// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rcti-detail-page {
  --rcti-warning-bg: var(--warning-soft, #fef8ec);
  --rcti-warning-text: var(--warning-text, #7d4412);
  --rcti-success-bg: var(--success-soft, #edfbf2);
  --rcti-success-text: var(--success-text, #115a33);
  --rcti-info-bg: var(--info-soft, #eff6ff);
  --rcti-info-text: var(--info-text, #1d4ed8);
}
.rcti-type-emphasis {
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-md);
}
.rcti-detail-back {
  margin: 0 0 8px;
}
.rcti-detail-header {
  margin-bottom: 20px;
}
.rcti-detail-header h1.type-h1 {
  font: var(--font-weight-semibold) var(--font-size-h1) / var(--line-height-h1)
    var(--font-family-primary);
  letter-spacing: var(--letter-spacing-h1);
}
.rcti-detail-header p {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
}
.rcti-detail-header p span {
  margin-right: 0;
}
.rcti-detail-header p span:not(.rcti-document-number):not(.rcti-status) {
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-md);
}
.rcti-detail-header .rcti-document-number {
  font: var(--font-weight-medium) var(--font-size-doc-number) /
    var(--line-height-doc-number) var(--font-family-mono);
  letter-spacing: var(--letter-spacing-doc-number);
}
.rcti-detail-contact-link {
  color: inherit;
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-md);
  text-decoration: none;
  text-underline-offset: 2px;
}
.rcti-detail-contact-link:hover {
  text-decoration: underline;
  color: #0f766e;
}
.rcti-detail-contact-link:focus-visible {
  border-radius: 2px;
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 2px;
}
.rcti-status {
  display: inline-flex;
  min-height: 22px;
  box-sizing: border-box;
  align-items: center;
  padding: 2px 7px;
  border-radius: var(--radius-pill, 999px);
  font: var(--font-weight-regular) var(--font-size-caption-sm) /
    var(--line-height-caption-sm) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-caption-sm);
  white-space: nowrap;
}
.rcti-status.status-payment-due,
.rcti-status.status-overdue-payable {
  background: var(--rcti-warning-bg);
  color: var(--rcti-warning-text);
}
.rcti-status.status-paid {
  background: var(--success-soft, #edfbf2);
  color: var(--success-text, #115a33);
}
.rcti-status.status-sent {
  background: var(--info-soft, #eff6ff);
  color: var(--info-text, #1d4ed8);
}
.rcti-status.status-draft {
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
}
.rcti-status.status-voided {
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
}
.rcti-detail-shell.dark .rcti-status.status-payment-due,
.rcti-detail-shell.dark .rcti-status.status-overdue-payable {
  background: var(--warning-soft, #342b1d);
  color: var(--warning-text, #e6c78c);
}
.rcti-detail-shell.dark .rcti-status.status-paid {
  background: var(--success-soft, #1b2d25);
  color: var(--success-text, #94d3af);
}
.rcti-detail-shell.dark .rcti-status.status-sent {
  background: var(--info-soft, #202b3f);
  color: var(--info-text, #9bbcff);
}
.rcti-detail-shell.dark .rcti-status.status-draft,
.rcti-detail-shell.dark .rcti-status.status-voided {
  background: var(--surface-tertiary, #2b2f35);
  color: var(--text-secondary, #b3b8c2);
}
.rcti-detail-header .invoice-editor-actions button.primary {
  min-width: 152px;
}
.rcti-detail-context {
  display: flex;
  min-height: 74px;
  box-sizing: border-box;
  align-items: center;
  gap: 16px;
  margin: 0 0 24px;
  padding: 16px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}
.rcti-detail-context > div {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-direction: column;
  gap: 4px;
}
.rcti-detail-context .rcti-type-emphasis {
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-md);
}
.rcti-detail-context span {
  color: var(--text-secondary, #506360);
  font: var(--font-weight-regular) var(--font-size-caption-md) /
    var(--line-height-caption-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-caption-md);
}
.rcti-detail-context a {
  display: inline-flex;
  min-height: 40px;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  border-radius: 8px;
  color: var(--text-link, #0f766e);
  font-size: 12px;
  text-decoration: none;
}
.rcti-detail-context a:hover {
  background: var(--interactive-soft, #f0f8f7);
}
.rcti-detail-context a:focus-visible {
  outline: 2px solid var(--focus-ring, #0f766e);
  outline-offset: 2px;
}
.rcti-detail-context a svg {
  width: 14px;
  height: 14px;
}
.rcti-detail-context > .rcti-detail-context-reference {
  display: inline-flex;
  min-height: 40px;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  border-radius: var(--radius-md, 10px);
  color: var(--text-link, #0f766e);
  font: var(--font-weight-medium) 13px / normal var(--font-family-primary);
  letter-spacing: 0;
  white-space: nowrap;
}
.rcti-detail-context-reference svg {
  width: 16px;
  height: 16px;
}
.rcti-detail-layout {
  display: grid;
  width: 100%;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 320px);
  grid-template-areas: "document side";
  align-items: start;
  gap: 24px;
}
.rcti-detail-document {
  grid-area: document;
  min-width: 0;
  overflow: hidden;
}
.rcti-detail-aside {
  grid-area: side;
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 24px;
}
.rcti-detail-aside .invoice-flow-card {
  width: 100%;
}
.rcti-paper-heading {
  display: flex;
  min-height: 49px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.rcti-paper-heading > .rcti-type-emphasis {
  color: var(--text-primary, #142624);
  font: var(--font-weight-medium) 16px/22.4px var(--font-family-primary);
  letter-spacing: -0.08px;
}
.rcti-paper-identity {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.rcti-paper-identity span {
  color: var(--text-primary, #142624);
  font: var(--font-weight-medium) 16px/22.4px var(--font-family-primary);
  letter-spacing: -0.08px;
}
.rcti-paper-identity .rcti-type-emphasis {
  color: var(--text-primary, #142624);
  font: var(--font-weight-medium) var(--font-size-doc-number) /
    var(--line-height-doc-number) var(--font-family-mono);
  letter-spacing: var(--letter-spacing-doc-number);
}
.rcti-detail-page .rcti-detail-document > hr {
  margin: 16px 0;
  border: 0;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.rcti-detail-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px 24px;
}
.rcti-detail-meta > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
}
.rcti-detail-meta span {
  color: var(--text-secondary, #506360);
  font: var(--font-weight-regular) var(--font-size-caption-md) /
    var(--line-height-caption-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-caption-md);
}
.rcti-detail-meta .rcti-type-emphasis {
  overflow-wrap: anywhere;
  color: var(--text-primary, #142624);
  font: var(--font-weight-regular) 13px/20.2px var(--font-family-primary);
  letter-spacing: 0;
}
.rcti-detail-section-heading {
  margin: 0 0 12px;
  font: var(--font-weight-medium) 16px/22.4px var(--font-family-primary);
  letter-spacing: -0.08px;
}
.rcti-detail-section-description {
  margin: 0 0 12px;
  color: var(--text-secondary, #506360);
  font: var(--font-weight-regular) var(--font-size-caption-md) /
    var(--line-height-caption-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-caption-md);
}
.rcti-detail-page .rcti-detail-items .head,
.rcti-detail-page .rcti-detail-items .row {
  grid-template-columns: minmax(0, 344fr) 40fr 104fr 52fr 76fr 112fr;
  gap: 0;
}
.rcti-detail-page .rcti-detail-items .head {
  min-height: 44px;
  padding: 0;
  border-radius: 6px;
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-secondary, #506360);
  font: var(--font-weight-medium) 11px/14.3px var(--font-family-primary);
  letter-spacing: 0.11px;
}
.rcti-detail-page .rcti-detail-items .head span {
  padding: 0;
}
.rcti-detail-page .rcti-detail-items .head span:not(:first-child),
.rcti-detail-page .rcti-detail-items .row > span:not(:first-child),
.rcti-detail-page .rcti-detail-items .row > .rcti-type-emphasis:last-child {
  text-align: right;
}
.rcti-detail-page .rcti-detail-items .row {
  min-height: 54px;
  padding: 0;
  border-color: var(--border-subtle, #dce3e2);
  color: var(--text-primary, #142624);
  font: var(--font-weight-regular) 13px/20.2px var(--font-family-primary);
  letter-spacing: 0;
}
.rcti-detail-page .rcti-detail-items .row > * {
  min-width: 0;
  padding: 0;
}
.rcti-detail-page .rcti-detail-items .row > .rcti-type-emphasis:first-child {
  overflow-wrap: anywhere;
  font: var(--font-weight-regular) 13px/20.2px var(--font-family-primary);
}
.rcti-detail-page .rcti-detail-items .row > span:nth-child(3),
.rcti-detail-page .rcti-detail-items .row > .rcti-type-emphasis:last-child {
  color: var(--text-primary, #142624);
  font: var(--font-weight-medium) 15px/19.5px var(--font-family-mono);
}
.rcti-detail-page .rcti-detail-summary {
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  gap: 24px;
  margin-top: 16px;
}
.rcti-detail-page .rcti-detail-summary > div:first-child > div {
  margin-bottom: 20px;
}
.rcti-detail-page .rcti-detail-summary > div:first-child p {
  margin: 7px 0 0;
  overflow-wrap: anywhere;
  color: var(--text-primary, #142624);
  font: var(--font-weight-regular) var(--font-size-body-sm) /
    var(--line-height-body-sm) var(--font-family-primary);
}
.rcti-detail-page .rcti-detail-summary > div:last-child p {
  font: var(--font-weight-regular) var(--font-size-caption-md) /
    var(--line-height-caption-md) var(--font-family-primary);
}
.rcti-detail-page .rcti-detail-summary > div:last-child hr {
  margin: 16px 0;
}
.rcti-detail-page
  .rcti-detail-summary
  > div:last-child
  .rcti-summary-explainer {
  display: block;
  margin: 0;
  color: var(--text-secondary, #506360);
  font: var(--font-weight-regular) 13px/18.2px var(--font-family-primary);
  letter-spacing: 0.065px;
}
.rcti-detail-page .rcti-detail-summary > div:last-child .rcti-type-emphasis {
  color: var(--text-primary, #142624);
  font: var(--font-weight-medium) 15px/19.5px var(--font-family-mono);
}
.rcti-detail-page .rcti-detail-summary .grand .rcti-type-emphasis {
  color: var(--text-primary, #142624);
  font: var(--font-weight-bold) 20px/24px var(--font-family-mono);
}
.rcti-detail-attachments {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 0 0 16px;
  color: var(--text-primary, #142624);
  font: var(--font-weight-medium) var(--font-size-caption-md) /
    var(--line-height-caption-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-caption-md);
}
.rcti-detail-attachments span:last-child {
  color: var(--text-secondary, #506360);
  text-align: right;
  font-weight: var(--font-weight-regular);
}
.rcti-detail-instructions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.rcti-detail-instructions span {
  color: var(--text-secondary, #506360);
  font: var(--font-weight-regular) var(--font-size-caption-md) /
    var(--line-height-caption-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-caption-md);
}
.rcti-detail-instructions span:last-child {
  overflow-wrap: anywhere;
  color: var(--text-primary, #142624);
  font: var(--font-weight-regular) var(--font-size-body-sm) /
    var(--line-height-body-sm) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-body-sm);
}
.rcti-detail-page .invoice-total-card > .rcti-type-emphasis {
  display: block;
  margin: 24px 0 8px;
  font: var(--font-weight-bold) 20px/24px var(--font-family-mono);
}
.rcti-balance-card > p {
  padding-bottom: 58px;
  font: var(--font-weight-regular) 13px/18.2px var(--font-family-primary);
  letter-spacing: 0.065px;
}
.rcti-balance-card .rcti-payment-breakdown {
  gap: 16px;
}
.rcti-payment-breakdown {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0;
  padding-top: 16px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.rcti-payment-breakdown > p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font: var(--font-weight-regular) 13px/18.2px var(--font-family-primary);
  letter-spacing: 0.065px;
}
.rcti-payment-breakdown > div {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}
.rcti-payment-breakdown span {
  color: var(--text-secondary, #506360);
  font: var(--font-weight-regular) var(--font-size-caption-md) /
    var(--line-height-caption-md) var(--font-family-primary);
}
.rcti-payment-breakdown .rcti-type-emphasis {
  color: var(--text-primary, #142624);
  font: var(--font-weight-medium) var(--font-size-money-md) /
    var(--line-height-money-md) var(--font-family-mono);
  text-align: right;
}
.rcti-detail-action {
  display: inline-flex;
  height: 40px;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 500 13px / normal var(--font-family-primary, "Lexend", sans-serif);
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.rcti-detail-action:hover:not(:disabled) {
  border-color: var(--interactive-default, #0f766e);
  color: var(--interactive-default, #0f766e);
}
.rcti-detail-action:focus-visible {
  outline: 2px solid var(--focus-ring, #0f766e);
  outline-offset: 2px;
}
.rcti-detail-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.rcti-detail-action svg {
  width: 16px;
  height: 16px;
}
.rcti-detail-action.primary {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
}
.rcti-detail-action.primary:hover:not(:disabled) {
  border-color: var(--interactive-hover, #0a655f);
  background: var(--interactive-hover, #0a655f);
  color: var(--on-interactive-primary, #fff);
}
.rcti-delivery-card > h2 {
  margin-bottom: 16px;
}
.rcti-delivery-card > .rcti-detail-meta {
  grid-template-columns: 1fr;
  gap: 16px;
}
.rcti-delivery-card > .rcti-detail-meta > div {
  gap: 6px;
}
.rcti-delivery-status {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rcti-delivery-status p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 11px;
}
.rcti-delivery-copy {
  margin: 0;
  color: var(--text-secondary, #506360);
  font: var(--font-weight-regular) 13px/18.2px var(--font-family-primary);
  letter-spacing: 0.065px;
}
.rcti-delivery-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
}
.rcti-delivery-actions .rcti-detail-action {
  width: auto;
  min-width: 132px;
}
.rcti-delivery-actions .rcti-detail-action + .rcti-detail-action {
  min-width: 182px;
  border-color: transparent;
  background: transparent;
  color: var(--text-link, #0f766e);
}
.rcti-delivery-card {
  display: flex;
  min-height: 557px;
  flex-direction: column;
  gap: 16px;
}
.rcti-delivery-card > h2 {
  margin: 0;
}
.rcti-delivery-card > .rcti-detail-meta {
  margin: 0;
}
.rcti-delivery-card hr {
  width: 100%;
  margin: 0;
  border: 0;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.rcti-reminder-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.rcti-reminder-section h3 {
  margin: 0;
  font: var(--font-weight-medium) 16px/22.4px var(--font-family-primary);
  letter-spacing: -0.08px;
}
.rcti-reminder-section p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font: var(--font-weight-regular) 13px/18.2px var(--font-family-primary);
  letter-spacing: 0.065px;
}
.rcti-reminder-section .rcti-reminder-status:nth-of-type(2) {
  color: var(--text-primary, #142624);
  font: var(--font-weight-regular) 13px/20.2px var(--font-family-primary);
  letter-spacing: 0;
}
.rcti-reminder-section .rcti-detail-action {
  width: 100%;
  margin: 0;
}
.rcti-balance-card > .rcti-detail-action.primary {
  width: 100%;
}
.rcti-detail-lower-panels {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  margin-top: 24px;
}
.rcti-detail-lower-panels .invoice-flow-card {
  min-width: 0;
}
.rcti-detail-lower-panels .invoice-flow-card h2 {
  margin-bottom: 18px;
}
.rcti-detail-lower-panels > .rcti-detail-state-card {
  min-height: 275px;
  gap: 0;
  margin: 0;
}
.rcti-detail-lower-panels .rcti-detail-state-card h2.type-h4 {
  margin: 0 0 16px;
}
.rcti-state-financial-row {
  display: flex;
  min-height: 21px;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}
.rcti-state-financial-row > span:first-child {
  color: var(--text-secondary, #506360);
  font: var(--font-weight-regular) var(--font-size-caption-md) /
    var(--line-height-caption-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-caption-md);
}
.rcti-state-financial-row .rcti-type-emphasis {
  color: var(--text-primary, #142624);
  font: var(--font-weight-medium) var(--font-size-money-md) /
    var(--line-height-money-md) var(--font-family-mono);
}
.rcti-detail-state-card > hr {
  width: 100%;
  margin: 16px 0;
  border: 0;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.rcti-payment-empty-copy {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.rcti-payment-empty-copy > span,
.rcti-state-empty-title {
  color: var(--text-primary, #142624);
  font: var(--font-weight-regular) var(--font-size-body-sm) /
    var(--line-height-body-sm) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-body-sm);
}
.rcti-payment-empty-copy p,
.rcti-state-description {
  margin: 0;
  color: var(--text-secondary, #506360);
  font: var(--font-weight-regular) var(--font-size-caption-md) /
    var(--line-height-caption-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-caption-md);
}
.rcti-detail-state-card > .rcti-detail-action {
  align-self: flex-start;
  margin-top: 16px;
}
.rcti-detail-shell.dark .rcti-detail-state-card > hr {
  border-color: var(--border-subtle);
}
.rcti-detail-history {
  margin-top: 24px;
}
.rcti-detail-history > p {
  margin: 5px 0 16px;
  color: var(--text-secondary, #506360);
  font-size: 12px;
  line-height: 17px;
}
.rcti-detail-history .invoice-private-note {
  margin: 16px 0;
}
.rcti-history-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 24px;
  align-items: start;
}
.rcti-history-feed {
  display: grid;
  gap: 12px;
}
.rcti-history-feed article {
  padding: 14px 16px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 8px;
  background: var(--surface-primary, #fff);
}
.rcti-history-feed article > div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.rcti-history-feed .rcti-type-emphasis {
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-md);
}
.rcti-history-feed time {
  color: var(--text-secondary, #506360);
  font-size: 10px;
}
.rcti-history-feed p {
  margin: 8px 0 0;
  overflow-wrap: anywhere;
  font-size: 11px;
  line-height: 17px;
}
.rcti-note-composer {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.rcti-note-composer label {
  color: var(--text-primary, #142624);
  font-size: 12px;
  font-weight: 500;
}
.rcti-note-composer textarea {
  box-sizing: border-box;
  width: 100%;
  min-height: 143px;
  margin-top: 8px;
  padding: 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 12px/18px var(--font-family-primary, "Lexend", sans-serif);
  resize: vertical;
}
.rcti-note-composer textarea:focus {
  border-color: var(--interactive-default, #0f766e);
  outline: 0;
  box-shadow: none;
}
.rcti-note-composer small {
  color: var(--text-secondary, #506360);
  font-size: 10px;
}
.rcti-note-composer button {
  align-self: flex-end;
}
.rcti-empty-line {
  padding: 12px 0;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  color: var(--text-secondary, #506360);
  font-size: 11px;
}
.rcti-history-footnote {
  margin: 16px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 10px;
  line-height: 15px;
}
.rcti-detail-page .invoice-status {
  font: var(--font-weight-regular) var(--font-size-caption-sm) /
    var(--line-height-caption-sm) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-caption-sm);
}
.rcti-detail-page h2.type-h4 {
  font: var(--font-weight-medium) 16px/22.4px var(--font-family-primary);
  letter-spacing: -0.08px;
}
.rcti-detail-page h2.type-h5 {
  font: var(--font-weight-medium) var(--font-size-h5) / var(--line-height-h5)
    var(--font-family-primary);
  letter-spacing: var(--letter-spacing-h5);
}
.rcti-communication-header h2.type-h4,
.rcti-payment-dialog-header h2.type-h4 {
  font: var(--font-weight-medium) var(--font-size-h4) / var(--line-height-h4)
    var(--font-family-primary);
  letter-spacing: var(--letter-spacing-h4);
}

/* Match the Figma desktop proportions and let the document column use wider screens. */
@media (min-width: 1024px) {
  .rcti-detail-page > .rcti-detail-back,
  .rcti-detail-page > .rcti-detail-header,
  .rcti-detail-page > .rcti-detail-context,
  .rcti-detail-page > .rcti-detail-layout,
  .rcti-detail-page > .rcti-detail-lower-panels,
  .rcti-detail-page > .rcti-detail-history {
    max-width: none;
  }

  .rcti-detail-layout {
    grid-template-columns: minmax(0, 1fr) minmax(280px, 320px);
    gap: 24px;
  }
}

.rcti-communication-backdrop {
  position: fixed;
  z-index: 1450;
  inset: 0;
  display: grid;
  place-items: center;
  box-sizing: border-box;
  padding: 24px;
  background: var(--overlay-heavy, rgb(0 0 0 / 70%));
}
.rcti-communication-dialog {
  width: min(100%, 664px);
  max-height: min(92vh, 820px);
  overflow: auto;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  box-shadow: var(--elevation-large, 0 24px 48px -12px rgba(0, 0, 0, 0.22));
}
.rcti-communication-header {
  display: flex;
  min-height: 72px;
  box-sizing: border-box;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.rcti-communication-heading-icon {
  display: grid;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  place-items: center;
  color: var(--interactive-default, #0f766e);
}
.rcti-communication-heading-icon svg {
  width: 20px;
  height: 20px;
}
.rcti-communication-header h2 {
  flex: 1 1;
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
}
.rcti-communication-close {
  display: grid;
  width: 32px;
  height: 40px;
  flex: 0 0 32px;
  place-items: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.rcti-communication-close:hover:not(:disabled) {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}
.rcti-communication-close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.rcti-communication-dialog form {
  padding: 16px 20px 0;
}
.rcti-communication-feedback {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 8px;
  font-size: 11px;
  line-height: 16px;
}
.rcti-communication-feedback .rcti-type-emphasis {
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-md);
}
.rcti-communication-feedback span {
  color: var(--text-secondary, #506360);
}
.rcti-communication-feedback.busy {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}
.rcti-communication-feedback.error {
  background: var(--danger-soft, #fef2f1);
  color: var(--danger-text, #a3301f);
}
.rcti-communication-feedback.error span {
  color: var(--text-secondary, #506360);
}
.rcti-communication-feedback.success {
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 12px;
  background: var(--success-soft, #edfbf2);
  color: var(--success-text, #115a33);
}
.rcti-communication-feedback.success svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}
.rcti-communication-feedback.success div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.rcti-communication-context {
  display: flex;
  min-height: 53px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 7px;
  margin-bottom: 12px;
  color: var(--text-primary, #142624);
  font: 500 11px/16px var(--font-family-mono, "JetBrains Mono", monospace);
}
.rcti-communication-context .rcti-status {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}
.rcti-communication-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0 0 12px;
  color: var(--text-primary, #142624);
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
}
.rcti-communication-field > input,
.rcti-recipient-box,
.rcti-communication-field textarea {
  box-sizing: border-box;
  width: 100%;
  min-height: 40px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 12px/18px var(--font-family-primary, "Lexend", sans-serif);
}
.rcti-communication-field > input {
  padding: 0 10px;
}
.rcti-communication-field > input[readonly] {
  cursor: default;
}
.rcti-communication-field textarea {
  min-height: 90px;
  padding: 10px;
  resize: vertical;
}
.rcti-email-message-help {
  color: var(--text-secondary, #506360);
  font-size: var(--font-size-caption-md, 11px);
  line-height: 1.5;
}
.rcti-communication-field > input:focus,
.rcti-recipient-box:focus-within,
.rcti-communication-field textarea:focus {
  border-color: var(--interactive-default, #0f766e);
  outline: 0;
  box-shadow: none;
}
.rcti-recipient-box {
  display: flex;
  min-height: 40px;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
}
.rcti-recipient-box > input {
  min-width: 130px;
  min-height: 28px;
  flex: 1 1;
  border: 0;
  outline: 0;
  background: transparent;
  color: inherit;
  font: inherit;
}
.rcti-recipient-box > input::placeholder {
  color: var(--text-tertiary, #6b7b78);
}
.rcti-recipient-box.is-disabled {
  background: var(--surface-secondary, #f4f7f7);
}
.rcti-recipient-chip {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  gap: 4px;
  padding: 3px 6px 3px 8px;
  border-radius: var(--radius-pill, 999px);
  background: var(--interactive-soft, #f0f8f7);
  color: var(--text-primary, #142624);
  font-size: 10px;
  line-height: 16px;
  overflow-wrap: anywhere;
}
.rcti-recipient-chip button {
  display: grid;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  place-items: center;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--text-secondary, #506360);
  font-size: 15px;
  cursor: pointer;
}
.rcti-communication-link {
  display: flex;
  min-height: 66px;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  margin-top: 4px;
  padding: 12px;
  border-radius: 8px;
  background: var(--surface-secondary, #f4f7f7);
}
.rcti-communication-link .rcti-type-emphasis {
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-md);
}
.rcti-communication-link span {
  color: var(--text-secondary, #506360);
  font-size: 10px;
  line-height: 15px;
}
.rcti-communication-options {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 10px 0;
}
.rcti-communication-options label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: var(--text-primary, #142624);
  font-size: 10px;
  line-height: 16px;
}
.rcti-communication-options input {
  width: 14px;
  height: 14px;
  margin: 0;
  accent-color: var(--interactive-default, #0f766e);
}
.rcti-communication-options input:disabled {
  opacity: 1;
}
.rcti-communication-disclaimer {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 10px;
  line-height: 15px;
}
.rcti-communication-validation {
  margin: 8px 0 0;
  color: var(--danger-text, #a3301f);
  font-size: 11px;
}
.rcti-communication-actions {
  display: flex;
  min-height: 72px;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin: 14px -20px 0;
  padding: 16px 20px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.rcti-communication-actions button,
.rcti-communication-view {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 500 11px/16px var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.rcti-communication-actions button:hover:not(:disabled),
.rcti-communication-view:hover {
  border-color: var(--interactive-default, #0f766e);
  color: var(--interactive-default, #0f766e);
}
.rcti-communication-actions button.primary,
.rcti-communication-view {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
}
.rcti-communication-actions button.primary:hover:not(:disabled),
.rcti-communication-view:hover {
  border-color: var(--interactive-hover, #0a655f);
  background: var(--interactive-hover, #0a655f);
  color: var(--on-interactive-primary, #fff);
}
.rcti-communication-actions button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.rcti-communication-actions button svg {
  width: 14px;
  height: 14px;
}
.rcti-communication-success {
  padding: 20px;
}
.rcti-communication-record {
  margin: 0 0 12px;
  color: var(--text-primary, #142624);
  font: 500 11px/16px var(--font-family-mono, "JetBrains Mono", monospace);
  text-transform: uppercase;
}
.rcti-communication-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.rcti-communication-money {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 9px 0;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  color: var(--text-secondary, #506360);
  font-size: 11px;
}
.rcti-communication-money .rcti-type-emphasis {
  color: var(--text-primary, #142624);
  font: var(--font-weight-medium) var(--font-size-money-md) /
    var(--line-height-money-md) var(--font-family-mono);
  text-align: right;
}
.rcti-communication-due {
  margin: 12px 0 6px;
  color: var(--text-primary, #142624);
  font-size: 11px;
}
.rcti-communication-help {
  margin: 0 0 12px;
  color: var(--text-secondary, #506360);
  font-size: 10px;
  line-height: 15px;
}
.rcti-communication-view {
  min-height: 40px;
}
.is-spinning {
  animation: rcti-spin 0.9s linear infinite;
}
@keyframes rcti-spin {
  to {
    transform: rotate(360deg);
  }
}

.rcti-detail-shell.dark .rcti-detail-context {
  border-color: var(--border-subtle);
  background: var(--surface-secondary);
  color: var(--text-primary);
}
.rcti-detail-shell.dark .rcti-detail-context span,
.rcti-detail-shell.dark .rcti-detail-context a {
  color: var(--text-secondary);
}
.rcti-detail-shell.dark .rcti-detail-context .rcti-detail-context-reference {
  color: var(--text-link);
}
.rcti-detail-shell.dark .rcti-detail-context a:hover {
  background: var(--surface-tertiary);
  color: var(--interactive-default);
}
.rcti-detail-shell.dark .rcti-detail-page .rcti-detail-document > hr,
.rcti-detail-shell.dark .rcti-payment-breakdown,
.rcti-detail-shell.dark .rcti-delivery-card hr {
  border-color: var(--border-subtle);
}
.rcti-detail-shell.dark .rcti-detail-page .rcti-detail-items .head {
  background: var(--surface-secondary);
  color: var(--text-secondary);
}
.rcti-detail-shell.dark .rcti-detail-page .rcti-detail-items .row {
  border-color: var(--border-subtle);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.rcti-detail-shell.dark .rcti-detail-history .invoice-private-note {
  background: var(--surface-secondary);
}
.rcti-detail-shell.dark .rcti-history-feed article {
  border-color: var(--border-subtle);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.rcti-detail-shell.dark .rcti-note-composer textarea {
  border-color: var(--border-default);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.rcti-detail-shell.dark .rcti-detail-action:not(.primary) {
  border-color: var(--border-default);
  background: var(--surface-secondary);
  color: var(--text-primary);
}
.rcti-detail-shell.dark .rcti-detail-action:not(.primary):hover:not(:disabled) {
  border-color: var(--interactive-default);
  color: var(--interactive-default);
}
.rcti-communication-backdrop.dark .rcti-communication-dialog {
  border-color: var(--border-subtle);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.rcti-communication-backdrop.dark .rcti-communication-header,
.rcti-communication-backdrop.dark .rcti-communication-actions {
  border-color: var(--border-subtle);
}
.rcti-communication-backdrop.dark .rcti-communication-field > input,
.rcti-communication-backdrop.dark .rcti-recipient-box,
.rcti-communication-backdrop.dark .rcti-communication-field textarea {
  border-color: var(--border-default);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.rcti-communication-backdrop.dark .rcti-recipient-chip {
  background: var(--surface-secondary);
  color: var(--text-primary);
}
.rcti-communication-backdrop.dark .rcti-communication-link,
.rcti-communication-backdrop.dark .rcti-communication-feedback.busy {
  background: var(--surface-secondary);
}
.rcti-communication-backdrop.dark .rcti-communication-feedback.error {
  background: var(--danger-soft);
  color: var(--danger-text);
}
.rcti-communication-backdrop.dark .rcti-communication-feedback.success {
  background: var(--success-soft);
  color: var(--success-text);
}
.rcti-communication-backdrop.dark
  .rcti-communication-actions
  button:not(.primary) {
  border-color: var(--border-default);
  background: var(--surface-secondary);
  color: var(--text-primary);
}
.rcti-communication-backdrop.dark .rcti-communication-actions button.primary,
.rcti-communication-backdrop.dark .rcti-communication-view {
  border-color: var(--interactive-default);
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
}
.rcti-communication-backdrop.dark .rcti-communication-money,
.rcti-communication-backdrop.dark .rcti-communication-due {
  border-color: var(--border-subtle);
  color: var(--text-secondary);
}
.rcti-communication-backdrop.dark .rcti-communication-money .rcti-type-emphasis,
.rcti-communication-backdrop.dark .rcti-communication-record {
  color: var(--text-primary);
}

@media (min-width: 1024px) and (max-width: 1439px) {
  .rcti-detail-layout {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .rcti-detail-aside {
    display: contents;
    position: static;
  }
  .rcti-detail-aside > .rcti-balance-card {
    order: -1;
  }
  .rcti-detail-layout > .rcti-detail-document {
    order: 1;
    width: 100%;
  }
  .rcti-detail-aside > .rcti-delivery-card {
    order: 2;
  }
  .rcti-detail-layout > .invoice-flow-card {
    width: 100%;
  }
}

@media (max-width: 1023px) {
  .rcti-detail-layout {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .rcti-detail-aside {
    display: contents;
    position: static;
  }
  .rcti-detail-aside > .rcti-balance-card {
    order: -1;
  }
  .rcti-detail-layout > .rcti-detail-document {
    order: 1;
    width: 100%;
  }
  .rcti-detail-aside > .rcti-delivery-card {
    order: 2;
  }
  .rcti-detail-page .rcti-delivery-card {
    min-height: 0;
  }
  .rcti-detail-layout > .invoice-flow-card {
    width: 100%;
  }
  .rcti-detail-page .rcti-detail-items .head {
    display: none;
  }
  .rcti-detail-page .rcti-detail-items .row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px 16px;
    min-height: 0;
    margin-top: 12px;
    padding: 16px;
    border: 1px solid var(--border-subtle, #dce3e2);
    border-radius: var(--radius-md, 10px);
    background: var(--surface-primary, #fff);
    font: var(--font-weight-regular) var(--font-size-body-sm) /
      var(--line-height-body-sm) var(--font-family-primary);
    letter-spacing: var(--letter-spacing-body-sm);
  }
  .rcti-detail-page .rcti-detail-items .row > .rcti-type-emphasis:first-child {
    grid-column: 1/-1;
  }
  .rcti-detail-page .rcti-detail-items .row > span,
  .rcti-detail-page .rcti-detail-items .row > .rcti-type-emphasis[data-label] {
    display: flex;
    grid-column: 1/-1;
    justify-content: space-between;
    gap: 16px;
    text-align: right;
  }
  .rcti-detail-page .rcti-detail-items .row [data-label]::before {
    content: attr(data-label);
    color: var(--text-secondary, #506360);
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 11px;
    font-weight: 400;
    text-align: left;
  }
  .rcti-detail-page .rcti-detail-items .row .rcti-type-emphasis[data-label] {
    font-family: var(--font-family-mono, "JetBrains Mono", monospace);
    font-weight: 500;
  }
  .rcti-detail-page .rcti-detail-summary {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .rcti-detail-lower-panels {
    gap: 16px;
  }
  .rcti-detail-lower-panels > .rcti-detail-state-card {
    min-height: 0;
  }
  .rcti-history-layout {
    grid-template-columns: minmax(0, 1fr) 280px;
    gap: 16px;
  }
  .rcti-detail-shell.dark .rcti-detail-page .rcti-detail-items .row {
    border-color: var(--border-subtle);
    background: var(--surface-primary);
  }
}
@media (max-width: 700px) {
  .rcti-detail-context {
    align-items: flex-start;
    flex-wrap: wrap;
    padding: 12px;
  }
  .rcti-detail-context > div {
    flex: 1 1 100%;
  }
  .rcti-detail-context > .rcti-detail-context-reference {
    margin-left: auto;
  }
  .rcti-detail-context a {
    min-height: 36px;
    margin-left: auto;
    padding: 0 6px;
  }
  .rcti-detail-layout {
    gap: 12px;
  }
  .rcti-detail-aside > .rcti-balance-card {
    order: -2;
  }
  .rcti-detail-aside > .rcti-delivery-card {
    order: -1;
  }
  .rcti-detail-layout > .rcti-detail-document {
    order: 0;
  }
  .rcti-detail-page .rcti-detail-meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px 12px;
  }
  .rcti-detail-page .rcti-detail-summary {
    gap: 8px;
  }
  .rcti-detail-lower-panels {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-top: 12px;
  }
  .rcti-detail-history {
    margin-top: 12px;
  }
  .rcti-history-layout {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .rcti-history-feed article {
    padding: 12px;
  }
  .rcti-note-composer textarea {
    min-height: 120px;
  }
  .rcti-communication-backdrop {
    padding: 8px;
  }
  .rcti-communication-dialog {
    max-height: 96dvh;
    border-radius: 12px;
  }
  .rcti-communication-header {
    min-height: 60px;
    padding: 12px 16px;
  }
  .rcti-communication-dialog form {
    padding: 12px 16px 0;
  }
  .rcti-communication-actions {
    min-height: 64px;
    margin-right: -16px;
    margin-left: -16px;
    padding: 12px 16px;
  }
  .rcti-communication-success {
    padding: 16px;
  }
  .rcti-communication-actions button {
    min-height: 44px;
  }
}

/* Stage 4 settlement and Stage 5 overdue states */
.rcti-status.status-part-paid {
  background: var(--warning-soft, #fef8ec);
  color: var(--warning-text, #7d4412);
}
.rcti-detail-shell.dark .rcti-status.status-part-paid {
  background: var(--warning-soft);
  color: var(--warning-text);
}
.rcti-detail-page .invoice-inline-action:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.rcti-detail-page .invoice-inline-action:disabled:hover {
  border-color: var(--border-default, #cdd6d4);
  color: var(--text-primary, #142624);
}
.rcti-detail-context.overdue {
  border-color: color-mix(
    in srgb,
    var(--warning-default, #b7701a) 35%,
    var(--border-subtle, #dce3e2)
  );
  background: var(--warning-soft, #fef8ec);
}
.rcti-detail-context.overdue > svg {
  color: var(--warning-default, #b7701a);
}
.rcti-detail-shell.dark .rcti-detail-context.overdue {
  border-color: var(--warning-border, #695638);
  background: var(--warning-soft);
}
.rcti-overdue-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: -8px 0 20px;
  padding: 12px 16px;
  border: 1px solid
    color-mix(
      in srgb,
      var(--warning-default, #b7701a) 30%,
      var(--border-subtle, #dce3e2)
    );
  border-radius: var(--radius-md, 10px);
  background: var(--warning-soft, #fef8ec);
  color: var(--text-primary, #142624);
}
.rcti-overdue-notice > svg {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  color: var(--warning-default, #b7701a);
}
.rcti-overdue-notice > div {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-direction: column;
  gap: 3px;
}
.rcti-overdue-notice .rcti-type-emphasis {
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-md);
}
.rcti-overdue-notice span {
  color: var(--text-secondary, #506360);
  font-size: 12px;
  line-height: 17px;
}
.rcti-overdue-notice button,
.rcti-load-error button,
.rcti-history-load-error button {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 500 12px/16px var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.rcti-overdue-notice button:hover,
.rcti-load-error button:hover,
.rcti-history-load-error button:hover {
  border-color: var(--interactive-default, #0f766e);
  color: var(--interactive-default, #0f766e);
}
.rcti-settlement-limit {
  display: block;
  margin-top: 10px;
  color: var(--text-secondary, #506360);
  font-size: 11px;
  line-height: 16px;
}
.rcti-payment-exception-status {
  display: inline-flex;
  margin-left: 8px;
  padding: 2px 7px;
  border-radius: 999px;
  background: var(--warning-soft, #fef8ec);
  color: var(--warning-text, #7d4412);
  font-size: 10px;
  font-weight: 500;
}
.rcti-exception-copy {
  grid-column: 1/-1;
  color: var(--warning-text, #7d4412) !important;
}
.rcti-history-load-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 14px;
  padding: 12px;
  border: 1px solid var(--danger-default, #c23a2b);
  border-radius: 8px;
  background: var(--danger-soft, #fef2f1);
  color: var(--danger-text, #a3301f);
  font-size: 12px;
}
.rcti-history-load-error button {
  flex: 0 0 auto;
}
.rcti-load-error {
  display: flex;
  max-width: 760px;
  align-items: center;
  gap: 16px;
  margin: 36px auto;
  padding: 24px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  background: var(--surface-primary, #fff);
  box-shadow: 0 1px 2px rgb(14 26 32 / 6%);
}
.rcti-load-error > svg {
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  color: var(--danger-default, #c23a2b);
}
.rcti-load-error > div {
  flex: 1 1;
  min-width: 0;
}
.rcti-load-error h1 {
  margin: 0 0 6px;
  color: var(--text-primary, #142624);
  font-size: 18px;
}
.rcti-load-error p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 19px;
}
.rcti-payment-backdrop {
  position: fixed;
  z-index: 1500;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--overlay-default, rgb(0 0 0 / 45%));
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.rcti-payment-backdrop.dark {
  background: var(--overlay-default, rgb(0 0 0 / 60%)) !important;
}
.rcti-payment-dialog {
  display: flex;
  width: min(640px, 100%);
  max-height: min(90dvh, 760px);
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  background: var(--surface-primary, #fff);
  box-shadow: 0 12px 36px rgb(14 26 32 / 18%);
  color: var(--text-primary, #142624);
}
.rcti-payment-dialog form {
  display: flex;
  min-height: 0;
  flex: 1 1;
  flex-direction: column;
}
.rcti-payment-dialog-header {
  display: flex;
  min-height: 72px;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.rcti-payment-dialog-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
}
.rcti-payment-dialog-header button {
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.rcti-payment-dialog-header button:hover {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}
.rcti-payment-dialog-header button svg {
  width: 20px;
  height: 20px;
}
.rcti-payment-dialog-body {
  display: flex;
  min-height: 0;
  flex: 1 1;
  flex-direction: column;
  gap: 20px;
  overflow: auto;
  padding: 24px;
}
.rcti-payment-summary {
  padding: 16px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f7);
}
.rcti-payment-summary-top,
.rcti-payment-summary-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.rcti-payment-summary-top > span {
  font: 500 14px/20px var(--font-family-mono, "JetBrains Mono", monospace);
}
.rcti-payment-summary-main {
  margin-top: 12px;
}
.rcti-payment-summary-main > .rcti-type-emphasis {
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-md);
}
.rcti-payment-summary-main > span:not(.rcti-type-emphasis) {
  font: var(--font-weight-medium) var(--font-size-money-md) /
    var(--line-height-money-md) var(--font-family-mono);
  text-align: right;
}
.rcti-payment-summary > p {
  margin: 12px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 19px;
}
.rcti-payment-fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}
.rcti-payment-fields label {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 7px;
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: 500;
}
.rcti-payment-fields label input,
.rcti-payment-fields label select {
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  min-width: 0;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 13px/18px var(--font-family-primary, "Lexend", sans-serif);
}
.rcti-payment-fields label input:focus,
.rcti-payment-fields label select:focus {
  border-color: var(--interactive-default, #0f766e);
  outline: 0;
  box-shadow: none;
}
.rcti-payment-fields [aria-invalid="true"] {
  border-color: var(--danger-default, #c23a2b) !important;
}
.rcti-payment-fields .rcti-payment-input-with-prefix,
.rcti-payment-fields .rcti-payment-date-input {
  position: relative;
  display: flex;
  align-items: center;
}
.rcti-payment-input-with-prefix > span {
  position: absolute;
  left: 11px;
  color: var(--text-secondary, #506360);
  font-size: 11px;
  pointer-events: none;
}
.rcti-payment-input-with-prefix input {
  padding-left: 46px !important;
}
.rcti-payment-date-input svg {
  position: absolute;
  right: 12px;
  width: 16px;
  height: 16px;
  color: var(--text-secondary, #506360);
  pointer-events: none;
}
.rcti-payment-date-input input {
  padding-right: 36px !important;
}
.rcti-payment-fields .rcti-payment-reference {
  grid-column: 1/-1;
}
.rcti-payment-fields .field-error {
  color: var(--danger-text, #a3301f);
  font-size: 11px;
  font-weight: 400;
  line-height: 15px;
}
.rcti-payment-disclaimer {
  margin: -8px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 11px;
  line-height: 17px;
}
.rcti-payment-result {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 8px;
  font-size: 12px;
  line-height: 17px;
}
.rcti-payment-result > svg {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
}
.rcti-payment-result > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.rcti-payment-result .rcti-type-emphasis {
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-md);
}
.rcti-payment-result span {
  color: var(--text-secondary, #506360);
}
.rcti-payment-result.info {
  border-color: var(--info-border, #c8dcf8);
  background: var(--info-soft, #eff6ff);
  color: var(--info-text, #315b8f);
}
.rcti-payment-result.error {
  border-color: var(--danger-default, #c23a2b);
  background: var(--danger-soft, #fef2f1);
  color: var(--danger-text, #a3301f);
}
.rcti-payment-result.success {
  border-color: var(--success-default, #15703d);
  background: var(--success-soft, #edfbf2);
  color: var(--success-text, #115a33);
}
.rcti-payment-result.success > svg {
  color: var(--success-default, #15703d);
}
.rcti-payment-dialog-actions {
  display: flex;
  min-height: 72px;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 24px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.rcti-payment-dialog-actions button {
  display: inline-flex;
  height: 40px;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: normal 500 13px/normal var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.rcti-payment-dialog-actions button:hover:not(:disabled) {
  border-color: var(--interactive-default, #0f766e);
  color: var(--interactive-default, #0f766e);
}
.rcti-payment-dialog-actions button.primary {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
}
.rcti-payment-dialog-actions button.primary:hover:not(:disabled) {
  border-color: var(--interactive-hover, #0a655f);
  background: var(--interactive-hover, #0a655f);
  color: var(--on-interactive-primary, #fff);
}
.rcti-payment-dialog-actions button:disabled {
  border-color: var(--interactive-disabled, #cdd6d4);
  background: var(--interactive-disabled, #cdd6d4);
  color: var(--on-interactive-disabled, #8a9896);
  cursor: not-allowed;
}
.rcti-payment-dialog-actions button svg {
  width: 16px;
  height: 16px;
}
.rcti-payment-backdrop.dark .rcti-payment-dialog {
  border-color: var(--border-subtle);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.rcti-payment-backdrop.dark .rcti-payment-dialog-header,
.rcti-payment-backdrop.dark .rcti-payment-dialog-actions {
  border-color: var(--border-subtle);
}
.rcti-payment-backdrop.dark .rcti-payment-dialog-header button {
  color: var(--text-secondary);
}
.rcti-payment-backdrop.dark .rcti-payment-dialog-header button:hover {
  background: var(--surface-secondary);
  color: var(--text-primary);
}
.rcti-payment-backdrop.dark .rcti-payment-summary {
  border-color: var(--border-subtle);
  background: var(--surface-secondary);
}
.rcti-payment-backdrop.dark .rcti-payment-summary > p {
  color: var(--text-secondary);
}
.rcti-payment-backdrop.dark .rcti-payment-fields label input,
.rcti-payment-backdrop.dark .rcti-payment-fields label select {
  border-color: var(--border-default);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.rcti-payment-backdrop.dark .rcti-payment-disclaimer {
  color: var(--text-secondary);
}
.rcti-payment-backdrop.dark .rcti-payment-result.info {
  border-color: var(--info-border);
  background: var(--info-soft);
  color: var(--info-text);
}
.rcti-payment-backdrop.dark .rcti-payment-result.error {
  border-color: var(--danger-border);
  background: var(--danger-soft);
  color: var(--danger-text);
}
.rcti-payment-backdrop.dark .rcti-payment-result.success {
  border-color: var(--success-border);
  background: var(--success-soft);
  color: var(--success-text);
}
.rcti-payment-backdrop.dark .rcti-payment-result span {
  color: var(--text-secondary);
}
.rcti-payment-backdrop.dark .rcti-payment-dialog-actions button:not(.primary) {
  border-color: var(--border-default);
  background: var(--surface-secondary);
  color: var(--text-primary);
}
.rcti-payment-backdrop.dark .rcti-payment-dialog-actions button.primary {
  border-color: var(--interactive-default);
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
}
.rcti-payment-backdrop.dark .rcti-payment-dialog-actions button:disabled {
  border-color: var(--interactive-disabled);
  background: var(--interactive-disabled);
  color: var(--on-interactive-disabled);
}

@media (max-width: 700px) {
  .rcti-overdue-notice {
    align-items: flex-start;
    flex-wrap: wrap;
    margin: 0 0 12px;
    padding: 12px;
  }
  .rcti-overdue-notice > div {
    flex-basis: calc(100% - 38px);
  }
  .rcti-overdue-notice button {
    margin-left: 30px;
  }
  .rcti-load-error {
    flex-wrap: wrap;
    margin: 20px auto;
    padding: 16px;
  }
  .rcti-load-error > div {
    flex-basis: calc(100% - 42px);
  }
  .rcti-payment-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .rcti-payment-dialog {
    width: 100%;
    max-height: min(92dvh, 800px);
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
    border-radius: 16px 16px 0 0;
  }
  .rcti-payment-dialog-header {
    min-height: 60px;
    padding: 0 16px;
  }
  .rcti-payment-dialog-header h2 {
    font-size: 18px;
  }
  .rcti-payment-dialog-body {
    gap: 16px;
    padding: 16px;
  }
  .rcti-payment-summary {
    padding: 12px;
  }
  .rcti-payment-summary-main {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }
  .rcti-payment-fields {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .rcti-payment-fields .rcti-payment-reference {
    grid-column: auto;
  }
  .rcti-payment-dialog-actions {
    position: sticky;
    bottom: 0;
    min-height: 64px;
    padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
    background: var(--surface-primary, #fff);
  }
  .rcti-payment-dialog-actions button {
    min-height: 44px;
    flex: 1 1;
  }
  .rcti-payment-backdrop.dark .rcti-payment-dialog-actions {
    background: var(--surface-primary);
  }
  .rcti-history-load-error {
    align-items: flex-start;
    flex-direction: column;
  }
}

/* Invoice-style paper hierarchy shared by details, preview and website capture. */
.rcti-paper-business {
  display: grid;
  gap: var(--space-2);
  min-width: 0;
}
.rcti-paper-business > .rcti-type-emphasis {
  font-size: var(--font-size-h4);
}
.rcti-paper-business small,
.rcti-paper-parties small {
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
  overflow-wrap: anywhere;
}
.rcti-detail-document .rcti-document-eyebrow {
  font-size: var(--font-size-caption-md);
  letter-spacing: 0.7px;
  text-transform: uppercase;
  color: var(--text-secondary);
}
.rcti-detail-document .rcti-paper-identity h2 {
  margin: var(--space-1) 0;
  font-size: var(--font-size-h2);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}
.rcti-paper-parties {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: var(--space-5);
  padding: var(--space-4) 0 var(--space-6);
}
.rcti-paper-parties > div {
  display: grid;
  align-content: start;
  gap: var(--space-2);
  min-width: 0;
}
.rcti-paper-parties > div > span {
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}
.rcti-paper-parties strong {
  color: var(--text-primary);
  font-size: var(--font-size-body-md);
  font-weight: var(--font-weight-medium);
}
.rcti-preview-page {
  max-width: 1060px;
  margin: 0 auto;
  padding: var(--space-6);
}
.rcti-preview-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-4);
  margin-bottom: var(--space-6);
}
.rcti-preview-toolbar h1 {
  margin: 0;
  color: var(--text-primary);
  font-size: var(--font-size-h3);
}
.rcti-preview-toolbar p {
  margin: var(--space-1) 0 0;
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
.rcti-preview-toolbar__actions {
  display: flex;
  gap: var(--space-3);
  margin-left: auto;
}
.rcti-preview-toolbar button,
.rcti-preview-error button {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-height: 42px;
  padding: var(--space-3) var(--space-4);
  background: var(--surface-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  font: inherit;
  cursor: pointer;
}
.rcti-preview-toolbar button.primary {
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
  border-color: var(--interactive-default);
}
.rcti-preview-toolbar button:disabled {
  opacity: 0.5;
  cursor: default;
}
.rcti-preview-toolbar button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
.rcti-preview-error {
  color: var(--danger-text);
  background: var(--danger-soft);
  border: 1px solid var(--danger-default);
  border-radius: var(--radius-md);
  padding: var(--space-5);
}
@media (max-width: 600px) {
  .rcti-paper-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .rcti-paper-parties {
    grid-template-columns: 1fr;
  }
  .rcti-preview-page {
    padding: var(--space-4);
  }
  .rcti-preview-toolbar__actions {
    width: 100%;
    margin-left: 0;
  }
}
@media print {
  .rcti-preview-toolbar {
    display: none;
  }
  .rcti-preview-page {
    padding: 0;
    max-width: none;
  }
  .rcti-preview-page .rcti-detail-document {
    box-shadow: none;
    border: 0;
  }
}

.rcti-detail-items [data-label="GST"] small {
  display: block;
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}

.rcti-detail-document .rcti-paper-identity {
  flex: 1 1 55%;
  min-width: 0;
}
.rcti-paper-business {
  flex: 1 1 40%;
}
.rcti-document-table-scroll {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
}
.rcti-document-table {
  width: 100%;
  min-width: 680px;
  border-collapse: collapse;
  color: var(--text-primary);
  font-size: var(--font-size-body-sm);
}
.rcti-document-table th {
  padding: var(--space-3);
  background: var(--surface-secondary);
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
  font-weight: var(--font-weight-medium);
  border-bottom: 1px solid var(--border-default);
  text-align: right;
  white-space: nowrap;
}
.rcti-document-table td {
  padding: var(--space-4) var(--space-3);
  border-bottom: 1px solid var(--border-default);
  text-align: right;
  vertical-align: top;
  white-space: nowrap;
}
.rcti-document-table tbody tr:last-child td {
  border-bottom: 0;
}
.rcti-document-table th:first-child,
.rcti-document-table td:first-child {
  text-align: left;
  width: 40%;
  white-space: normal;
  min-width: 180px;
  overflow-wrap: anywhere;
}
.rcti-document-table strong {
  font-weight: var(--font-weight-medium);
}
.rcti-document-table small {
  display: block;
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
  white-space: normal;
  margin-top: var(--space-1);
}
@media print {
  .rcti-document-table-scroll {
    overflow: visible;
  }
  .rcti-document-table {
    min-width: 0;
  }
  .rcti-document-table thead {
    display: table-header-group;
  }
  .rcti-document-table tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}

/* Document totals and statutory notes must retain contrast in both themes. */
.rcti-detail-document .rcti-detail-section-description,
.rcti-detail-document .rcti-detail-summary p > span:first-child {
  color: var(--text-secondary);
}
.rcti-detail-document .rcti-detail-summary p > span:last-child {
  color: var(--text-primary);
}
.rcti-detail-document .rcti-detail-summary .grand {
  padding: var(--space-4);
  margin-top: var(--space-3);
  background: var(--surface-secondary);
  border-radius: var(--radius-md);
}
.rcti-detail-document .rcti-detail-summary .grand > span {
  color: var(--text-primary);
  font-weight: var(--font-weight-medium);
}
.rcti-detail-document hr {
  border-color: var(--border-default);
}
.rcti-paper-parties > div:last-child > strong {
  text-transform: capitalize;
}
@media print {
  .rcti-preview-shell,
  .rcti-detail-document {
    --surface-primary: #fff;
    --surface-secondary: #f4f7f7;
    --text-primary: #142624;
    --text-secondary: #506360;
    --border-default: #dce3e2;
    background: #fff !important;
  }
}
.rcti-detail-document .rcti-detail-summary .grand > span:last-child {
  font-size: var(--font-size-h4);
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/rctiDetail.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,iDAAiD;EACjD,+CAA+C;EAC/C,iDAAiD;EACjD,yCAAyC;EACzC,2CAA2C;AAC7C;AACA;EACE;0DACwD;EACxD,8CAA8C;AAChD;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;8BAC4B;EAC5B,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE;0DACwD;EACxD,8CAA8C;AAChD;AACA;EACE;yDACuD;EACvD,gDAAgD;AAClD;AACA;EACE,cAAc;EACd;0DACwD;EACxD,8CAA8C;EAC9C,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC;4DAC0D;EAC1D,gDAAgD;EAChD,mBAAmB;AACrB;AACA;;EAEE,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;AACA;EACE,4CAA4C;EAC5C,qCAAqC;AACvC;AACA;EACE,4CAA4C;EAC5C,qCAAqC;AACvC;AACA;;EAEE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;AACA;;EAEE,4CAA4C;EAC5C,qCAAqC;AACvC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,6CAA6C;EAC7C,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE;0DACwD;EACxD,8CAA8C;AAChD;AACA;EACE,qCAAqC;EACrC;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qCAAqC;EACrC,gCAAgC;EAChC,wEAAwE;EACxE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,WAAW;EACX,0DAA0D;EAC1D,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,mCAAmC;EACnC,sEAAsE;EACtE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,mCAAmC;EACnC,sEAAsE;EACtE,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC;yDACuD;EACvD,gDAAgD;AAClD;AACA;EACE,cAAc;EACd,SAAS;EACT,mDAAmD;AACrD;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,qCAAqC;EACrC;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,uEAAuE;EACvE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,sEAAsE;EACtE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;;EAEE,kEAAkE;EAClE,MAAM;AACR;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,6CAA6C;EAC7C,qCAAqC;EACrC,sEAAsE;EACtE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,2CAA2C;EAC3C,mCAAmC;EACnC,uEAAuE;EACvE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,uEAAuE;AACzE;AACA;;EAEE,mCAAmC;EACnC,mEAAmE;AACrE;AACA;EACE,sDAAsD;EACtD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,mCAAmC;EACnC;yDACuD;AACzD;AACA;EACE;4DAC0D;AAC5D;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,cAAc;EACd,SAAS;EACT,qCAAqC;EACrC,uEAAuE;EACvE,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,mEAAmE;AACrE;AACA;EACE,mCAAmC;EACnC,+DAA+D;AACjE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,qCAAqC;EACrC;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE,uBAAuB;EACvB,mCAAmC;EACnC;yDACuD;EACvD,6CAA6C;AAC/C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,+DAA+D;AACjE;AACA;EACE,oBAAoB;EACpB,uEAAuE;EACvE,uBAAuB;AACzB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,mDAAmD;AACrD;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,uEAAuE;EACvE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,qCAAqC;EACrC;4DAC0D;AAC5D;AACA;EACE,mCAAmC;EACnC;uDACqD;EACrD,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,wEAAwE;EACxE,qBAAqB;EACrB,eAAe;EACf,4EAA4E;AAC9E;AACA;EACE,iDAAiD;EACjD,0CAA0C;AAC5C;AACA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;AAC5C;AACA;EACE,+CAA+C;EAC/C,6CAA6C;EAC7C,0CAA0C;AAC5C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,uEAAuE;EACvE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,SAAS;EACT,SAAS;EACT,mDAAmD;AACrD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;EACE,SAAS;EACT,sEAAsE;EACtE,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,uEAAuE;EACvE,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,uEAAuE;EACvE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,MAAM;EACN,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,qCAAqC;EACrC;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE,mCAAmC;EACnC;uDACqD;AACvD;AACA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,mDAAmD;AACrD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE,mCAAmC;EACnC;yDACuD;EACvD,6CAA6C;AAC/C;AACA;;EAEE,SAAS;EACT,qCAAqC;EACrC;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE;0DACwD;EACxD,8CAA8C;AAChD;AACA;EACE,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,gDAAgD;EAChD,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,oEAAoE;EACpE,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,sDAAsD;EACtD,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE,sEAAsE;EACtE,uBAAuB;AACzB;AACA;EACE;8BAC4B;EAC5B,wCAAwC;AAC1C;AACA;;EAEE;8BAC4B;EAC5B,wCAAwC;AAC1C;;AAEA,uFAAuF;AACvF;EACE;;;;;;IAME,eAAe;EACjB;;EAEA;IACE,0DAA0D;IAC1D,SAAS;EACX;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,kDAAkD;AACpD;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,yEAAyE;AAC3E;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;0DACwD;EACxD,8CAA8C;AAChD;AACA;EACE,qCAAqC;AACvC;AACA;EACE,6CAA6C;EAC7C,mCAAmC;AACrC;AACA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mCAAmC;EACnC,wEAAwE;AAC1E;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;EAGE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,oEAAoE;AACtE;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;;;EAGE,iDAAiD;EACjD,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;EACP,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;AACA;EACE,oCAAoC;AACtC;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,wCAAwC;EACxC,4CAA4C;EAC5C,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE;0DACwD;EACxD,8CAA8C;AAChD;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iDAAiD;AACnD;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,mDAAmD;AACrD;AACA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,oEAAoE;EACpE,eAAe;AACjB;AACA;;EAEE,iDAAiD;EACjD,0CAA0C;AAC5C;AACA;;EAEE,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;AAC5C;AACA;;EAEE,+CAA+C;EAC/C,6CAA6C;EAC7C,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,wEAAwE;EACxE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,sDAAsD;EACtD,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC;uDACqD;EACrD,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;AACA;;;EAGE,kCAAkC;AACpC;AACA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,wCAAwC;EACxC,iCAAiC;AACnC;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;;EAEE,kCAAkC;AACpC;AACA;;;EAGE,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;;;EAGE,mCAAmC;EACnC,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;;EAEE,wCAAwC;EACxC,sCAAsC;EACtC,oCAAoC;AACtC;AACA;;EAEE,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,0CAA0C;IAC1C,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,+CAA+C;IAC/C,qCAAqC;IACrC,wCAAwC;IACxC;2DACuD;IACvD,6CAA6C;EAC/C;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,qCAAqC;IACrC,6DAA6D;IAC7D,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,iEAAiE;IACjE,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,2CAA2C;IAC3C,SAAS;EACX;EACA;IACE,kCAAkC;IAClC,kCAAkC;EACpC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,eAAe;IACf,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,gDAAgD;IAChD,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,kDAAkD;AAClD;EACE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;AACA;EACE;;;;GAIC;EACD,wCAAwC;AAC1C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,4CAA4C;EAC5C,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB;;;;;KAKG;EACH,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE;0DACwD;EACxD,8CAA8C;AAChD;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;;;EAGE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,oEAAoE;EACpE,eAAe;AACjB;AACA;;;EAGE,iDAAiD;EACjD,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,kBAAkB;EAClB,uCAAuC;EACvC,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;AACvC;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oDAAoD;EACpD,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,+DAA+D;AACjE;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,2CAA2C;EAC3C,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,aAAa;EACb,SAAO;EACP,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sDAAsD;AACxD;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,6CAA6C;EAC7C,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,gBAAgB;AAClB;AACA;EACE;0DACwD;EACxD,8CAA8C;AAChD;AACA;EACE;uDACqD;EACrD,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,oEAAoE;AACtE;AACA;;EAEE,iDAAiD;EACjD,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,uDAAuD;AACzD;AACA;;EAEE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE;0DACwD;EACxD,8CAA8C;AAChD;AACA;EACE,qCAAqC;AACvC;AACA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,gCAAgC;AAClC;AACA;EACE,4CAA4C;EAC5C,uCAAuC;EACvC,kCAAkC;AACpC;AACA;EACE,6CAA6C;EAC7C,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,6EAA6E;EAC7E,eAAe;AACjB;AACA;EACE,iDAAiD;EACjD,0CAA0C;AAC5C;AACA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;AAC5C;AACA;EACE,+CAA+C;EAC/C,6CAA6C;EAC7C,0CAA0C;AAC5C;AACA;EACE,kDAAkD;EAClD,gDAAgD;EAChD,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;;EAEE,kCAAkC;AACpC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,oCAAoC;AACtC;AACA;EACE,yCAAyC;EACzC,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE;IACE,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,WAAW;IACX,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,4BAA4B;EAC9B;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;IACT,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,2DAA2D;IAC3D,wCAAwC;EAC1C;EACA;IACE,gBAAgB;IAChB,SAAO;EACT;EACA;IACE,kCAAkC;EACpC;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;EAC5B,mCAAmC;EACnC,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,kCAAkC;EAClC,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,cAAc;EAChB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,sCAAsC;EACtC,sCAAsC;EACtC,8CAA8C;EAC9C,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,8CAA8C;EAC9C,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;AACF;;AAEA,6EAA6E;AAC7E;;EAEE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;;IAEE,uBAAuB;IACvB,4BAA4B;IAC5B,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;AACA;EACE,8BAA8B;AAChC","sourcesContent":[".rcti-detail-page {\n  --rcti-warning-bg: var(--warning-soft, #fef8ec);\n  --rcti-warning-text: var(--warning-text, #7d4412);\n  --rcti-success-bg: var(--success-soft, #edfbf2);\n  --rcti-success-text: var(--success-text, #115a33);\n  --rcti-info-bg: var(--info-soft, #eff6ff);\n  --rcti-info-text: var(--info-text, #1d4ed8);\n}\n.rcti-type-emphasis {\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.rcti-detail-back {\n  margin: 0 0 8px;\n}\n.rcti-detail-header {\n  margin-bottom: 20px;\n}\n.rcti-detail-header h1.type-h1 {\n  font: var(--font-weight-semibold) var(--font-size-h1) / var(--line-height-h1)\n    var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-h1);\n}\n.rcti-detail-header p {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 12px;\n}\n.rcti-detail-header p span {\n  margin-right: 0;\n}\n.rcti-detail-header p span:not(.rcti-document-number):not(.rcti-status) {\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.rcti-detail-header .rcti-document-number {\n  font: var(--font-weight-medium) var(--font-size-doc-number) /\n    var(--line-height-doc-number) var(--font-family-mono);\n  letter-spacing: var(--letter-spacing-doc-number);\n}\n.rcti-detail-contact-link {\n  color: inherit;\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-md);\n  text-decoration: none;\n  text-underline-offset: 2px;\n}\n.rcti-detail-contact-link:hover {\n  text-decoration: underline;\n  color: #0f766e;\n}\n.rcti-detail-contact-link:focus-visible {\n  border-radius: 2px;\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 2px;\n}\n.rcti-status {\n  display: inline-flex;\n  min-height: 22px;\n  box-sizing: border-box;\n  align-items: center;\n  padding: 2px 7px;\n  border-radius: var(--radius-pill, 999px);\n  font: var(--font-weight-regular) var(--font-size-caption-sm) /\n    var(--line-height-caption-sm) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-caption-sm);\n  white-space: nowrap;\n}\n.rcti-status.status-payment-due,\n.rcti-status.status-overdue-payable {\n  background: var(--rcti-warning-bg);\n  color: var(--rcti-warning-text);\n}\n.rcti-status.status-paid {\n  background: var(--success-soft, #edfbf2);\n  color: var(--success-text, #115a33);\n}\n.rcti-status.status-sent {\n  background: var(--info-soft, #eff6ff);\n  color: var(--info-text, #1d4ed8);\n}\n.rcti-status.status-draft {\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n}\n.rcti-status.status-voided {\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n}\n.rcti-detail-shell.dark .rcti-status.status-payment-due,\n.rcti-detail-shell.dark .rcti-status.status-overdue-payable {\n  background: var(--warning-soft, #342b1d);\n  color: var(--warning-text, #e6c78c);\n}\n.rcti-detail-shell.dark .rcti-status.status-paid {\n  background: var(--success-soft, #1b2d25);\n  color: var(--success-text, #94d3af);\n}\n.rcti-detail-shell.dark .rcti-status.status-sent {\n  background: var(--info-soft, #202b3f);\n  color: var(--info-text, #9bbcff);\n}\n.rcti-detail-shell.dark .rcti-status.status-draft,\n.rcti-detail-shell.dark .rcti-status.status-voided {\n  background: var(--surface-tertiary, #2b2f35);\n  color: var(--text-secondary, #b3b8c2);\n}\n.rcti-detail-header .invoice-editor-actions button.primary {\n  min-width: 152px;\n}\n.rcti-detail-context {\n  display: flex;\n  min-height: 74px;\n  box-sizing: border-box;\n  align-items: center;\n  gap: 16px;\n  margin: 0 0 24px;\n  padding: 16px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n.rcti-detail-context > div {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 4px;\n}\n.rcti-detail-context .rcti-type-emphasis {\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.rcti-detail-context span {\n  color: var(--text-secondary, #506360);\n  font: var(--font-weight-regular) var(--font-size-caption-md) /\n    var(--line-height-caption-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.rcti-detail-context a {\n  display: inline-flex;\n  min-height: 40px;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 6px;\n  padding: 0 10px;\n  border-radius: 8px;\n  color: var(--text-link, #0f766e);\n  font-size: 12px;\n  text-decoration: none;\n}\n.rcti-detail-context a:hover {\n  background: var(--interactive-soft, #f0f8f7);\n}\n.rcti-detail-context a:focus-visible {\n  outline: 2px solid var(--focus-ring, #0f766e);\n  outline-offset: 2px;\n}\n.rcti-detail-context a svg {\n  width: 14px;\n  height: 14px;\n}\n.rcti-detail-context > .rcti-detail-context-reference {\n  display: inline-flex;\n  min-height: 40px;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px;\n  border-radius: var(--radius-md, 10px);\n  color: var(--text-link, #0f766e);\n  font: var(--font-weight-medium) 13px / normal var(--font-family-primary);\n  letter-spacing: 0;\n  white-space: nowrap;\n}\n.rcti-detail-context-reference svg {\n  width: 16px;\n  height: 16px;\n}\n.rcti-detail-layout {\n  display: grid;\n  width: 100%;\n  grid-template-columns: minmax(0, 1fr) minmax(280px, 320px);\n  grid-template-areas: \"document side\";\n  align-items: start;\n  gap: 24px;\n}\n.rcti-detail-document {\n  grid-area: document;\n  min-width: 0;\n  overflow: hidden;\n}\n.rcti-detail-aside {\n  grid-area: side;\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 24px;\n}\n.rcti-detail-aside .invoice-flow-card {\n  width: 100%;\n}\n.rcti-paper-heading {\n  display: flex;\n  min-height: 49px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n.rcti-paper-heading > .rcti-type-emphasis {\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-medium) 16px/22.4px var(--font-family-primary);\n  letter-spacing: -0.08px;\n}\n.rcti-paper-identity {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n.rcti-paper-identity span {\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-medium) 16px/22.4px var(--font-family-primary);\n  letter-spacing: -0.08px;\n}\n.rcti-paper-identity .rcti-type-emphasis {\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-medium) var(--font-size-doc-number) /\n    var(--line-height-doc-number) var(--font-family-mono);\n  letter-spacing: var(--letter-spacing-doc-number);\n}\n.rcti-detail-page .rcti-detail-document > hr {\n  margin: 16px 0;\n  border: 0;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.rcti-detail-meta {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px 24px;\n}\n.rcti-detail-meta > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 8px;\n}\n.rcti-detail-meta span {\n  color: var(--text-secondary, #506360);\n  font: var(--font-weight-regular) var(--font-size-caption-md) /\n    var(--line-height-caption-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.rcti-detail-meta .rcti-type-emphasis {\n  overflow-wrap: anywhere;\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-regular) 13px/20.2px var(--font-family-primary);\n  letter-spacing: 0;\n}\n.rcti-detail-section-heading {\n  margin: 0 0 12px;\n  font: var(--font-weight-medium) 16px/22.4px var(--font-family-primary);\n  letter-spacing: -0.08px;\n}\n.rcti-detail-section-description {\n  margin: 0 0 12px;\n  color: var(--text-secondary, #506360);\n  font: var(--font-weight-regular) var(--font-size-caption-md) /\n    var(--line-height-caption-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.rcti-detail-page .rcti-detail-items .head,\n.rcti-detail-page .rcti-detail-items .row {\n  grid-template-columns: minmax(0, 344fr) 40fr 104fr 52fr 76fr 112fr;\n  gap: 0;\n}\n.rcti-detail-page .rcti-detail-items .head {\n  min-height: 44px;\n  padding: 0;\n  border-radius: 6px;\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-secondary, #506360);\n  font: var(--font-weight-medium) 11px/14.3px var(--font-family-primary);\n  letter-spacing: 0.11px;\n}\n.rcti-detail-page .rcti-detail-items .head span {\n  padding: 0;\n}\n.rcti-detail-page .rcti-detail-items .head span:not(:first-child),\n.rcti-detail-page .rcti-detail-items .row > span:not(:first-child),\n.rcti-detail-page .rcti-detail-items .row > .rcti-type-emphasis:last-child {\n  text-align: right;\n}\n.rcti-detail-page .rcti-detail-items .row {\n  min-height: 54px;\n  padding: 0;\n  border-color: var(--border-subtle, #dce3e2);\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-regular) 13px/20.2px var(--font-family-primary);\n  letter-spacing: 0;\n}\n.rcti-detail-page .rcti-detail-items .row > * {\n  min-width: 0;\n  padding: 0;\n}\n.rcti-detail-page .rcti-detail-items .row > .rcti-type-emphasis:first-child {\n  overflow-wrap: anywhere;\n  font: var(--font-weight-regular) 13px/20.2px var(--font-family-primary);\n}\n.rcti-detail-page .rcti-detail-items .row > span:nth-child(3),\n.rcti-detail-page .rcti-detail-items .row > .rcti-type-emphasis:last-child {\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-medium) 15px/19.5px var(--font-family-mono);\n}\n.rcti-detail-page .rcti-detail-summary {\n  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);\n  gap: 24px;\n  margin-top: 16px;\n}\n.rcti-detail-page .rcti-detail-summary > div:first-child > div {\n  margin-bottom: 20px;\n}\n.rcti-detail-page .rcti-detail-summary > div:first-child p {\n  margin: 7px 0 0;\n  overflow-wrap: anywhere;\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-regular) var(--font-size-body-sm) /\n    var(--line-height-body-sm) var(--font-family-primary);\n}\n.rcti-detail-page .rcti-detail-summary > div:last-child p {\n  font: var(--font-weight-regular) var(--font-size-caption-md) /\n    var(--line-height-caption-md) var(--font-family-primary);\n}\n.rcti-detail-page .rcti-detail-summary > div:last-child hr {\n  margin: 16px 0;\n}\n.rcti-detail-page\n  .rcti-detail-summary\n  > div:last-child\n  .rcti-summary-explainer {\n  display: block;\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font: var(--font-weight-regular) 13px/18.2px var(--font-family-primary);\n  letter-spacing: 0.065px;\n}\n.rcti-detail-page .rcti-detail-summary > div:last-child .rcti-type-emphasis {\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-medium) 15px/19.5px var(--font-family-mono);\n}\n.rcti-detail-page .rcti-detail-summary .grand .rcti-type-emphasis {\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-bold) 20px/24px var(--font-family-mono);\n}\n.rcti-detail-attachments {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin: 0 0 16px;\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-medium) var(--font-size-caption-md) /\n    var(--line-height-caption-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.rcti-detail-attachments span:last-child {\n  color: var(--text-secondary, #506360);\n  text-align: right;\n  font-weight: var(--font-weight-regular);\n}\n.rcti-detail-instructions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.rcti-detail-instructions span {\n  color: var(--text-secondary, #506360);\n  font: var(--font-weight-regular) var(--font-size-caption-md) /\n    var(--line-height-caption-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.rcti-detail-instructions span:last-child {\n  overflow-wrap: anywhere;\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-regular) var(--font-size-body-sm) /\n    var(--line-height-body-sm) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-body-sm);\n}\n.rcti-detail-page .invoice-total-card > .rcti-type-emphasis {\n  display: block;\n  margin: 24px 0 8px;\n  font: var(--font-weight-bold) 20px/24px var(--font-family-mono);\n}\n.rcti-balance-card > p {\n  padding-bottom: 58px;\n  font: var(--font-weight-regular) 13px/18.2px var(--font-family-primary);\n  letter-spacing: 0.065px;\n}\n.rcti-balance-card .rcti-payment-breakdown {\n  gap: 16px;\n}\n.rcti-payment-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin: 16px 0;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.rcti-payment-breakdown > p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font: var(--font-weight-regular) 13px/18.2px var(--font-family-primary);\n  letter-spacing: 0.065px;\n}\n.rcti-payment-breakdown > div {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n.rcti-payment-breakdown span {\n  color: var(--text-secondary, #506360);\n  font: var(--font-weight-regular) var(--font-size-caption-md) /\n    var(--line-height-caption-md) var(--font-family-primary);\n}\n.rcti-payment-breakdown .rcti-type-emphasis {\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-medium) var(--font-size-money-md) /\n    var(--line-height-money-md) var(--font-family-mono);\n  text-align: right;\n}\n.rcti-detail-action {\n  display: inline-flex;\n  height: 40px;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 500 13px / normal var(--font-family-primary, \"Lexend\", sans-serif);\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n.rcti-detail-action:hover:not(:disabled) {\n  border-color: var(--interactive-default, #0f766e);\n  color: var(--interactive-default, #0f766e);\n}\n.rcti-detail-action:focus-visible {\n  outline: 2px solid var(--focus-ring, #0f766e);\n  outline-offset: 2px;\n}\n.rcti-detail-action:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.rcti-detail-action svg {\n  width: 16px;\n  height: 16px;\n}\n.rcti-detail-action.primary {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n}\n.rcti-detail-action.primary:hover:not(:disabled) {\n  border-color: var(--interactive-hover, #0a655f);\n  background: var(--interactive-hover, #0a655f);\n  color: var(--on-interactive-primary, #fff);\n}\n.rcti-delivery-card > h2 {\n  margin-bottom: 16px;\n}\n.rcti-delivery-card > .rcti-detail-meta {\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n.rcti-delivery-card > .rcti-detail-meta > div {\n  gap: 6px;\n}\n.rcti-delivery-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.rcti-delivery-status p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n}\n.rcti-delivery-copy {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font: var(--font-weight-regular) 13px/18.2px var(--font-family-primary);\n  letter-spacing: 0.065px;\n}\n.rcti-delivery-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0;\n}\n.rcti-delivery-actions .rcti-detail-action {\n  width: auto;\n  min-width: 132px;\n}\n.rcti-delivery-actions .rcti-detail-action + .rcti-detail-action {\n  min-width: 182px;\n  border-color: transparent;\n  background: transparent;\n  color: var(--text-link, #0f766e);\n}\n.rcti-delivery-card {\n  display: flex;\n  min-height: 557px;\n  flex-direction: column;\n  gap: 16px;\n}\n.rcti-delivery-card > h2 {\n  margin: 0;\n}\n.rcti-delivery-card > .rcti-detail-meta {\n  margin: 0;\n}\n.rcti-delivery-card hr {\n  width: 100%;\n  margin: 0;\n  border: 0;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.rcti-reminder-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n.rcti-reminder-section h3 {\n  margin: 0;\n  font: var(--font-weight-medium) 16px/22.4px var(--font-family-primary);\n  letter-spacing: -0.08px;\n}\n.rcti-reminder-section p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font: var(--font-weight-regular) 13px/18.2px var(--font-family-primary);\n  letter-spacing: 0.065px;\n}\n.rcti-reminder-section .rcti-reminder-status:nth-of-type(2) {\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-regular) 13px/20.2px var(--font-family-primary);\n  letter-spacing: 0;\n}\n.rcti-reminder-section .rcti-detail-action {\n  width: 100%;\n  margin: 0;\n}\n.rcti-balance-card > .rcti-detail-action.primary {\n  width: 100%;\n}\n.rcti-detail-lower-panels {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 24px;\n  margin-top: 24px;\n}\n.rcti-detail-lower-panels .invoice-flow-card {\n  min-width: 0;\n}\n.rcti-detail-lower-panels .invoice-flow-card h2 {\n  margin-bottom: 18px;\n}\n.rcti-detail-lower-panels > .rcti-detail-state-card {\n  min-height: 275px;\n  gap: 0;\n  margin: 0;\n}\n.rcti-detail-lower-panels .rcti-detail-state-card h2.type-h4 {\n  margin: 0 0 16px;\n}\n.rcti-state-financial-row {\n  display: flex;\n  min-height: 21px;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n.rcti-state-financial-row > span:first-child {\n  color: var(--text-secondary, #506360);\n  font: var(--font-weight-regular) var(--font-size-caption-md) /\n    var(--line-height-caption-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.rcti-state-financial-row .rcti-type-emphasis {\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-medium) var(--font-size-money-md) /\n    var(--line-height-money-md) var(--font-family-mono);\n}\n.rcti-detail-state-card > hr {\n  width: 100%;\n  margin: 16px 0;\n  border: 0;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.rcti-payment-empty-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.rcti-payment-empty-copy > span,\n.rcti-state-empty-title {\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-regular) var(--font-size-body-sm) /\n    var(--line-height-body-sm) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-body-sm);\n}\n.rcti-payment-empty-copy p,\n.rcti-state-description {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font: var(--font-weight-regular) var(--font-size-caption-md) /\n    var(--line-height-caption-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.rcti-detail-state-card > .rcti-detail-action {\n  align-self: flex-start;\n  margin-top: 16px;\n}\n.rcti-detail-shell.dark .rcti-detail-state-card > hr {\n  border-color: var(--border-subtle);\n}\n.rcti-detail-history {\n  margin-top: 24px;\n}\n.rcti-detail-history > p {\n  margin: 5px 0 16px;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  line-height: 17px;\n}\n.rcti-detail-history .invoice-private-note {\n  margin: 16px 0;\n}\n.rcti-history-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 320px;\n  gap: 24px;\n  align-items: start;\n}\n.rcti-history-feed {\n  display: grid;\n  gap: 12px;\n}\n.rcti-history-feed article {\n  padding: 14px 16px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 8px;\n  background: var(--surface-primary, #fff);\n}\n.rcti-history-feed article > div {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n.rcti-history-feed .rcti-type-emphasis {\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.rcti-history-feed time {\n  color: var(--text-secondary, #506360);\n  font-size: 10px;\n}\n.rcti-history-feed p {\n  margin: 8px 0 0;\n  overflow-wrap: anywhere;\n  font-size: 11px;\n  line-height: 17px;\n}\n.rcti-note-composer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.rcti-note-composer label {\n  color: var(--text-primary, #142624);\n  font-size: 12px;\n  font-weight: 500;\n}\n.rcti-note-composer textarea {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 143px;\n  margin-top: 8px;\n  padding: 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 12px/18px var(--font-family-primary, \"Lexend\", sans-serif);\n  resize: vertical;\n}\n.rcti-note-composer textarea:focus {\n  border-color: var(--interactive-default, #0f766e);\n  outline: 0;\n  box-shadow: none;\n}\n.rcti-note-composer small {\n  color: var(--text-secondary, #506360);\n  font-size: 10px;\n}\n.rcti-note-composer button {\n  align-self: flex-end;\n}\n.rcti-empty-line {\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n}\n.rcti-history-footnote {\n  margin: 16px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 10px;\n  line-height: 15px;\n}\n.rcti-detail-page .invoice-status {\n  font: var(--font-weight-regular) var(--font-size-caption-sm) /\n    var(--line-height-caption-sm) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-caption-sm);\n}\n.rcti-detail-page h2.type-h4 {\n  font: var(--font-weight-medium) 16px/22.4px var(--font-family-primary);\n  letter-spacing: -0.08px;\n}\n.rcti-detail-page h2.type-h5 {\n  font: var(--font-weight-medium) var(--font-size-h5) / var(--line-height-h5)\n    var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-h5);\n}\n.rcti-communication-header h2.type-h4,\n.rcti-payment-dialog-header h2.type-h4 {\n  font: var(--font-weight-medium) var(--font-size-h4) / var(--line-height-h4)\n    var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-h4);\n}\n\n/* Match the Figma desktop proportions and let the document column use wider screens. */\n@media (min-width: 1024px) {\n  .rcti-detail-page > .rcti-detail-back,\n  .rcti-detail-page > .rcti-detail-header,\n  .rcti-detail-page > .rcti-detail-context,\n  .rcti-detail-page > .rcti-detail-layout,\n  .rcti-detail-page > .rcti-detail-lower-panels,\n  .rcti-detail-page > .rcti-detail-history {\n    max-width: none;\n  }\n\n  .rcti-detail-layout {\n    grid-template-columns: minmax(0, 1fr) minmax(280px, 320px);\n    gap: 24px;\n  }\n}\n\n.rcti-communication-backdrop {\n  position: fixed;\n  z-index: 1450;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  box-sizing: border-box;\n  padding: 24px;\n  background: var(--overlay-heavy, rgb(0 0 0 / 70%));\n}\n.rcti-communication-dialog {\n  width: min(100%, 664px);\n  max-height: min(92vh, 820px);\n  overflow: auto;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  box-shadow: var(--elevation-large, 0 24px 48px -12px rgba(0, 0, 0, 0.22));\n}\n.rcti-communication-header {\n  display: flex;\n  min-height: 72px;\n  box-sizing: border-box;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.rcti-communication-heading-icon {\n  display: grid;\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n  place-items: center;\n  color: var(--interactive-default, #0f766e);\n}\n.rcti-communication-heading-icon svg {\n  width: 20px;\n  height: 20px;\n}\n.rcti-communication-header h2 {\n  flex: 1;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n}\n.rcti-communication-close {\n  display: grid;\n  width: 32px;\n  height: 40px;\n  flex: 0 0 32px;\n  place-items: center;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.rcti-communication-close:hover:not(:disabled) {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n.rcti-communication-close:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n.rcti-communication-dialog form {\n  padding: 16px 20px 0;\n}\n.rcti-communication-feedback {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 12px;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 11px;\n  line-height: 16px;\n}\n.rcti-communication-feedback .rcti-type-emphasis {\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.rcti-communication-feedback span {\n  color: var(--text-secondary, #506360);\n}\n.rcti-communication-feedback.busy {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n.rcti-communication-feedback.error {\n  background: var(--danger-soft, #fef2f1);\n  color: var(--danger-text, #a3301f);\n}\n.rcti-communication-feedback.error span {\n  color: var(--text-secondary, #506360);\n}\n.rcti-communication-feedback.success {\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0 0 12px;\n  background: var(--success-soft, #edfbf2);\n  color: var(--success-text, #115a33);\n}\n.rcti-communication-feedback.success svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n}\n.rcti-communication-feedback.success div {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.rcti-communication-context {\n  display: flex;\n  min-height: 53px;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 7px;\n  margin-bottom: 12px;\n  color: var(--text-primary, #142624);\n  font: 500 11px/16px var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.rcti-communication-context .rcti-status {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.rcti-communication-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0 0 12px;\n  color: var(--text-primary, #142624);\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 16px;\n}\n.rcti-communication-field > input,\n.rcti-recipient-box,\n.rcti-communication-field textarea {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 40px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 12px/18px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.rcti-communication-field > input {\n  padding: 0 10px;\n}\n.rcti-communication-field > input[readonly] {\n  cursor: default;\n}\n.rcti-communication-field textarea {\n  min-height: 90px;\n  padding: 10px;\n  resize: vertical;\n}\n.rcti-email-message-help {\n  color: var(--text-secondary, #506360);\n  font-size: var(--font-size-caption-md, 11px);\n  line-height: 1.5;\n}\n.rcti-communication-field > input:focus,\n.rcti-recipient-box:focus-within,\n.rcti-communication-field textarea:focus {\n  border-color: var(--interactive-default, #0f766e);\n  outline: 0;\n  box-shadow: none;\n}\n.rcti-recipient-box {\n  display: flex;\n  min-height: 40px;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n}\n.rcti-recipient-box > input {\n  min-width: 130px;\n  min-height: 28px;\n  flex: 1;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n}\n.rcti-recipient-box > input::placeholder {\n  color: var(--text-tertiary, #6b7b78);\n}\n.rcti-recipient-box.is-disabled {\n  background: var(--surface-secondary, #f4f7f7);\n}\n.rcti-recipient-chip {\n  display: inline-flex;\n  max-width: 100%;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 6px 3px 8px;\n  border-radius: var(--radius-pill, 999px);\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--text-primary, #142624);\n  font-size: 10px;\n  line-height: 16px;\n  overflow-wrap: anywhere;\n}\n.rcti-recipient-chip button {\n  display: grid;\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  place-items: center;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  font-size: 15px;\n  cursor: pointer;\n}\n.rcti-communication-link {\n  display: flex;\n  min-height: 66px;\n  flex-direction: column;\n  justify-content: center;\n  gap: 4px;\n  margin-top: 4px;\n  padding: 12px;\n  border-radius: 8px;\n  background: var(--surface-secondary, #f4f7f7);\n}\n.rcti-communication-link .rcti-type-emphasis {\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.rcti-communication-link span {\n  color: var(--text-secondary, #506360);\n  font-size: 10px;\n  line-height: 15px;\n}\n.rcti-communication-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin: 10px 0;\n}\n.rcti-communication-options label {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: var(--text-primary, #142624);\n  font-size: 10px;\n  line-height: 16px;\n}\n.rcti-communication-options input {\n  width: 14px;\n  height: 14px;\n  margin: 0;\n  accent-color: var(--interactive-default, #0f766e);\n}\n.rcti-communication-options input:disabled {\n  opacity: 1;\n}\n.rcti-communication-disclaimer {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 10px;\n  line-height: 15px;\n}\n.rcti-communication-validation {\n  margin: 8px 0 0;\n  color: var(--danger-text, #a3301f);\n  font-size: 11px;\n}\n.rcti-communication-actions {\n  display: flex;\n  min-height: 72px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  margin: 14px -20px 0;\n  padding: 16px 20px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.rcti-communication-actions button,\n.rcti-communication-view {\n  display: inline-flex;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 500 11px/16px var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.rcti-communication-actions button:hover:not(:disabled),\n.rcti-communication-view:hover {\n  border-color: var(--interactive-default, #0f766e);\n  color: var(--interactive-default, #0f766e);\n}\n.rcti-communication-actions button.primary,\n.rcti-communication-view {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n}\n.rcti-communication-actions button.primary:hover:not(:disabled),\n.rcti-communication-view:hover {\n  border-color: var(--interactive-hover, #0a655f);\n  background: var(--interactive-hover, #0a655f);\n  color: var(--on-interactive-primary, #fff);\n}\n.rcti-communication-actions button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.rcti-communication-actions button svg {\n  width: 14px;\n  height: 14px;\n}\n.rcti-communication-success {\n  padding: 20px;\n}\n.rcti-communication-record {\n  margin: 0 0 12px;\n  color: var(--text-primary, #142624);\n  font: 500 11px/16px var(--font-family-mono, \"JetBrains Mono\", monospace);\n  text-transform: uppercase;\n}\n.rcti-communication-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n.rcti-communication-money {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 9px 0;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n}\n.rcti-communication-money .rcti-type-emphasis {\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-medium) var(--font-size-money-md) /\n    var(--line-height-money-md) var(--font-family-mono);\n  text-align: right;\n}\n.rcti-communication-due {\n  margin: 12px 0 6px;\n  color: var(--text-primary, #142624);\n  font-size: 11px;\n}\n.rcti-communication-help {\n  margin: 0 0 12px;\n  color: var(--text-secondary, #506360);\n  font-size: 10px;\n  line-height: 15px;\n}\n.rcti-communication-view {\n  min-height: 40px;\n}\n.is-spinning {\n  animation: rcti-spin 0.9s linear infinite;\n}\n@keyframes rcti-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.rcti-detail-shell.dark .rcti-detail-context {\n  border-color: var(--border-subtle);\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n}\n.rcti-detail-shell.dark .rcti-detail-context span,\n.rcti-detail-shell.dark .rcti-detail-context a {\n  color: var(--text-secondary);\n}\n.rcti-detail-shell.dark .rcti-detail-context .rcti-detail-context-reference {\n  color: var(--text-link);\n}\n.rcti-detail-shell.dark .rcti-detail-context a:hover {\n  background: var(--surface-tertiary);\n  color: var(--interactive-default);\n}\n.rcti-detail-shell.dark .rcti-detail-page .rcti-detail-document > hr,\n.rcti-detail-shell.dark .rcti-payment-breakdown,\n.rcti-detail-shell.dark .rcti-delivery-card hr {\n  border-color: var(--border-subtle);\n}\n.rcti-detail-shell.dark .rcti-detail-page .rcti-detail-items .head {\n  background: var(--surface-secondary);\n  color: var(--text-secondary);\n}\n.rcti-detail-shell.dark .rcti-detail-page .rcti-detail-items .row {\n  border-color: var(--border-subtle);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.rcti-detail-shell.dark .rcti-detail-history .invoice-private-note {\n  background: var(--surface-secondary);\n}\n.rcti-detail-shell.dark .rcti-history-feed article {\n  border-color: var(--border-subtle);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.rcti-detail-shell.dark .rcti-note-composer textarea {\n  border-color: var(--border-default);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.rcti-detail-shell.dark .rcti-detail-action:not(.primary) {\n  border-color: var(--border-default);\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n}\n.rcti-detail-shell.dark .rcti-detail-action:not(.primary):hover:not(:disabled) {\n  border-color: var(--interactive-default);\n  color: var(--interactive-default);\n}\n.rcti-communication-backdrop.dark .rcti-communication-dialog {\n  border-color: var(--border-subtle);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.rcti-communication-backdrop.dark .rcti-communication-header,\n.rcti-communication-backdrop.dark .rcti-communication-actions {\n  border-color: var(--border-subtle);\n}\n.rcti-communication-backdrop.dark .rcti-communication-field > input,\n.rcti-communication-backdrop.dark .rcti-recipient-box,\n.rcti-communication-backdrop.dark .rcti-communication-field textarea {\n  border-color: var(--border-default);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.rcti-communication-backdrop.dark .rcti-recipient-chip {\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n}\n.rcti-communication-backdrop.dark .rcti-communication-link,\n.rcti-communication-backdrop.dark .rcti-communication-feedback.busy {\n  background: var(--surface-secondary);\n}\n.rcti-communication-backdrop.dark .rcti-communication-feedback.error {\n  background: var(--danger-soft);\n  color: var(--danger-text);\n}\n.rcti-communication-backdrop.dark .rcti-communication-feedback.success {\n  background: var(--success-soft);\n  color: var(--success-text);\n}\n.rcti-communication-backdrop.dark\n  .rcti-communication-actions\n  button:not(.primary) {\n  border-color: var(--border-default);\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n}\n.rcti-communication-backdrop.dark .rcti-communication-actions button.primary,\n.rcti-communication-backdrop.dark .rcti-communication-view {\n  border-color: var(--interactive-default);\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n}\n.rcti-communication-backdrop.dark .rcti-communication-money,\n.rcti-communication-backdrop.dark .rcti-communication-due {\n  border-color: var(--border-subtle);\n  color: var(--text-secondary);\n}\n.rcti-communication-backdrop.dark .rcti-communication-money .rcti-type-emphasis,\n.rcti-communication-backdrop.dark .rcti-communication-record {\n  color: var(--text-primary);\n}\n\n@media (min-width: 1024px) and (max-width: 1439px) {\n  .rcti-detail-layout {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n  .rcti-detail-aside {\n    display: contents;\n    position: static;\n  }\n  .rcti-detail-aside > .rcti-balance-card {\n    order: -1;\n  }\n  .rcti-detail-layout > .rcti-detail-document {\n    order: 1;\n    width: 100%;\n  }\n  .rcti-detail-aside > .rcti-delivery-card {\n    order: 2;\n  }\n  .rcti-detail-layout > .invoice-flow-card {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1023px) {\n  .rcti-detail-layout {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n  .rcti-detail-aside {\n    display: contents;\n    position: static;\n  }\n  .rcti-detail-aside > .rcti-balance-card {\n    order: -1;\n  }\n  .rcti-detail-layout > .rcti-detail-document {\n    order: 1;\n    width: 100%;\n  }\n  .rcti-detail-aside > .rcti-delivery-card {\n    order: 2;\n  }\n  .rcti-detail-page .rcti-delivery-card {\n    min-height: 0;\n  }\n  .rcti-detail-layout > .invoice-flow-card {\n    width: 100%;\n  }\n  .rcti-detail-page .rcti-detail-items .head {\n    display: none;\n  }\n  .rcti-detail-page .rcti-detail-items .row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 10px 16px;\n    min-height: 0;\n    margin-top: 12px;\n    padding: 16px;\n    border: 1px solid var(--border-subtle, #dce3e2);\n    border-radius: var(--radius-md, 10px);\n    background: var(--surface-primary, #fff);\n    font: var(--font-weight-regular) var(--font-size-body-sm) /\n      var(--line-height-body-sm) var(--font-family-primary);\n    letter-spacing: var(--letter-spacing-body-sm);\n  }\n  .rcti-detail-page .rcti-detail-items .row > .rcti-type-emphasis:first-child {\n    grid-column: 1/-1;\n  }\n  .rcti-detail-page .rcti-detail-items .row > span,\n  .rcti-detail-page .rcti-detail-items .row > .rcti-type-emphasis[data-label] {\n    display: flex;\n    grid-column: 1/-1;\n    justify-content: space-between;\n    gap: 16px;\n    text-align: right;\n  }\n  .rcti-detail-page .rcti-detail-items .row [data-label]::before {\n    content: attr(data-label);\n    color: var(--text-secondary, #506360);\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 11px;\n    font-weight: 400;\n    text-align: left;\n  }\n  .rcti-detail-page .rcti-detail-items .row .rcti-type-emphasis[data-label] {\n    font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n    font-weight: 500;\n  }\n  .rcti-detail-page .rcti-detail-summary {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  .rcti-detail-lower-panels {\n    gap: 16px;\n  }\n  .rcti-detail-lower-panels > .rcti-detail-state-card {\n    min-height: 0;\n  }\n  .rcti-history-layout {\n    grid-template-columns: minmax(0, 1fr) 280px;\n    gap: 16px;\n  }\n  .rcti-detail-shell.dark .rcti-detail-page .rcti-detail-items .row {\n    border-color: var(--border-subtle);\n    background: var(--surface-primary);\n  }\n}\n@media (max-width: 700px) {\n  .rcti-detail-context {\n    align-items: flex-start;\n    flex-wrap: wrap;\n    padding: 12px;\n  }\n  .rcti-detail-context > div {\n    flex: 1 1 100%;\n  }\n  .rcti-detail-context > .rcti-detail-context-reference {\n    margin-left: auto;\n  }\n  .rcti-detail-context a {\n    min-height: 36px;\n    margin-left: auto;\n    padding: 0 6px;\n  }\n  .rcti-detail-layout {\n    gap: 12px;\n  }\n  .rcti-detail-aside > .rcti-balance-card {\n    order: -2;\n  }\n  .rcti-detail-aside > .rcti-delivery-card {\n    order: -1;\n  }\n  .rcti-detail-layout > .rcti-detail-document {\n    order: 0;\n  }\n  .rcti-detail-page .rcti-detail-meta {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 14px 12px;\n  }\n  .rcti-detail-page .rcti-detail-summary {\n    gap: 8px;\n  }\n  .rcti-detail-lower-panels {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    margin-top: 12px;\n  }\n  .rcti-detail-history {\n    margin-top: 12px;\n  }\n  .rcti-history-layout {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  .rcti-history-feed article {\n    padding: 12px;\n  }\n  .rcti-note-composer textarea {\n    min-height: 120px;\n  }\n  .rcti-communication-backdrop {\n    padding: 8px;\n  }\n  .rcti-communication-dialog {\n    max-height: 96dvh;\n    border-radius: 12px;\n  }\n  .rcti-communication-header {\n    min-height: 60px;\n    padding: 12px 16px;\n  }\n  .rcti-communication-dialog form {\n    padding: 12px 16px 0;\n  }\n  .rcti-communication-actions {\n    min-height: 64px;\n    margin-right: -16px;\n    margin-left: -16px;\n    padding: 12px 16px;\n  }\n  .rcti-communication-success {\n    padding: 16px;\n  }\n  .rcti-communication-actions button {\n    min-height: 44px;\n  }\n}\n\n/* Stage 4 settlement and Stage 5 overdue states */\n.rcti-status.status-part-paid {\n  background: var(--warning-soft, #fef8ec);\n  color: var(--warning-text, #7d4412);\n}\n.rcti-detail-shell.dark .rcti-status.status-part-paid {\n  background: var(--warning-soft);\n  color: var(--warning-text);\n}\n.rcti-detail-page .invoice-inline-action:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.rcti-detail-page .invoice-inline-action:disabled:hover {\n  border-color: var(--border-default, #cdd6d4);\n  color: var(--text-primary, #142624);\n}\n.rcti-detail-context.overdue {\n  border-color: color-mix(\n    in srgb,\n    var(--warning-default, #b7701a) 35%,\n    var(--border-subtle, #dce3e2)\n  );\n  background: var(--warning-soft, #fef8ec);\n}\n.rcti-detail-context.overdue > svg {\n  color: var(--warning-default, #b7701a);\n}\n.rcti-detail-shell.dark .rcti-detail-context.overdue {\n  border-color: var(--warning-border, #695638);\n  background: var(--warning-soft);\n}\n.rcti-overdue-notice {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: -8px 0 20px;\n  padding: 12px 16px;\n  border: 1px solid\n    color-mix(\n      in srgb,\n      var(--warning-default, #b7701a) 30%,\n      var(--border-subtle, #dce3e2)\n    );\n  border-radius: var(--radius-md, 10px);\n  background: var(--warning-soft, #fef8ec);\n  color: var(--text-primary, #142624);\n}\n.rcti-overdue-notice > svg {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  color: var(--warning-default, #b7701a);\n}\n.rcti-overdue-notice > div {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 3px;\n}\n.rcti-overdue-notice .rcti-type-emphasis {\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.rcti-overdue-notice span {\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  line-height: 17px;\n}\n.rcti-overdue-notice button,\n.rcti-load-error button,\n.rcti-history-load-error button {\n  display: inline-flex;\n  min-height: 36px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 10px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 500 12px/16px var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.rcti-overdue-notice button:hover,\n.rcti-load-error button:hover,\n.rcti-history-load-error button:hover {\n  border-color: var(--interactive-default, #0f766e);\n  color: var(--interactive-default, #0f766e);\n}\n.rcti-settlement-limit {\n  display: block;\n  margin-top: 10px;\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n  line-height: 16px;\n}\n.rcti-payment-exception-status {\n  display: inline-flex;\n  margin-left: 8px;\n  padding: 2px 7px;\n  border-radius: 999px;\n  background: var(--warning-soft, #fef8ec);\n  color: var(--warning-text, #7d4412);\n  font-size: 10px;\n  font-weight: 500;\n}\n.rcti-exception-copy {\n  grid-column: 1/-1;\n  color: var(--warning-text, #7d4412) !important;\n}\n.rcti-history-load-error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 14px;\n  padding: 12px;\n  border: 1px solid var(--danger-default, #c23a2b);\n  border-radius: 8px;\n  background: var(--danger-soft, #fef2f1);\n  color: var(--danger-text, #a3301f);\n  font-size: 12px;\n}\n.rcti-history-load-error button {\n  flex: 0 0 auto;\n}\n.rcti-load-error {\n  display: flex;\n  max-width: 760px;\n  align-items: center;\n  gap: 16px;\n  margin: 36px auto;\n  padding: 24px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 1px 2px rgb(14 26 32 / 6%);\n}\n.rcti-load-error > svg {\n  width: 22px;\n  height: 22px;\n  flex: 0 0 22px;\n  color: var(--danger-default, #c23a2b);\n}\n.rcti-load-error > div {\n  flex: 1;\n  min-width: 0;\n}\n.rcti-load-error h1 {\n  margin: 0 0 6px;\n  color: var(--text-primary, #142624);\n  font-size: 18px;\n}\n.rcti-load-error p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 19px;\n}\n.rcti-payment-backdrop {\n  position: fixed;\n  z-index: 1500;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: var(--overlay-default, rgb(0 0 0 / 45%));\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n.rcti-payment-backdrop.dark {\n  background: var(--overlay-default, rgb(0 0 0 / 60%)) !important;\n}\n.rcti-payment-dialog {\n  display: flex;\n  width: min(640px, 100%);\n  max-height: min(90dvh, 760px);\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 12px 36px rgb(14 26 32 / 18%);\n  color: var(--text-primary, #142624);\n}\n.rcti-payment-dialog form {\n  display: flex;\n  min-height: 0;\n  flex: 1;\n  flex-direction: column;\n}\n.rcti-payment-dialog-header {\n  display: flex;\n  min-height: 72px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.rcti-payment-dialog-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 28px;\n}\n.rcti-payment-dialog-header button {\n  display: grid;\n  width: 36px;\n  height: 36px;\n  place-items: center;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.rcti-payment-dialog-header button:hover {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n.rcti-payment-dialog-header button svg {\n  width: 20px;\n  height: 20px;\n}\n.rcti-payment-dialog-body {\n  display: flex;\n  min-height: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 20px;\n  overflow: auto;\n  padding: 24px;\n}\n.rcti-payment-summary {\n  padding: 16px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f7);\n}\n.rcti-payment-summary-top,\n.rcti-payment-summary-main {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n.rcti-payment-summary-top > span {\n  font: 500 14px/20px var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.rcti-payment-summary-main {\n  margin-top: 12px;\n}\n.rcti-payment-summary-main > .rcti-type-emphasis {\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.rcti-payment-summary-main > span:not(.rcti-type-emphasis) {\n  font: var(--font-weight-medium) var(--font-size-money-md) /\n    var(--line-height-money-md) var(--font-family-mono);\n  text-align: right;\n}\n.rcti-payment-summary > p {\n  margin: 12px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 19px;\n}\n.rcti-payment-fields {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n.rcti-payment-fields label {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 7px;\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: 500;\n}\n.rcti-payment-fields label input,\n.rcti-payment-fields label select {\n  box-sizing: border-box;\n  width: 100%;\n  height: 40px;\n  min-width: 0;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 13px/18px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.rcti-payment-fields label input:focus,\n.rcti-payment-fields label select:focus {\n  border-color: var(--interactive-default, #0f766e);\n  outline: 0;\n  box-shadow: none;\n}\n.rcti-payment-fields [aria-invalid=\"true\"] {\n  border-color: var(--danger-default, #c23a2b) !important;\n}\n.rcti-payment-fields .rcti-payment-input-with-prefix,\n.rcti-payment-fields .rcti-payment-date-input {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.rcti-payment-input-with-prefix > span {\n  position: absolute;\n  left: 11px;\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n  pointer-events: none;\n}\n.rcti-payment-input-with-prefix input {\n  padding-left: 46px !important;\n}\n.rcti-payment-date-input svg {\n  position: absolute;\n  right: 12px;\n  width: 16px;\n  height: 16px;\n  color: var(--text-secondary, #506360);\n  pointer-events: none;\n}\n.rcti-payment-date-input input {\n  padding-right: 36px !important;\n}\n.rcti-payment-fields .rcti-payment-reference {\n  grid-column: 1/-1;\n}\n.rcti-payment-fields .field-error {\n  color: var(--danger-text, #a3301f);\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 15px;\n}\n.rcti-payment-disclaimer {\n  margin: -8px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n  line-height: 17px;\n}\n.rcti-payment-result {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 8px;\n  font-size: 12px;\n  line-height: 17px;\n}\n.rcti-payment-result > svg {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n}\n.rcti-payment-result > div {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.rcti-payment-result .rcti-type-emphasis {\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.rcti-payment-result span {\n  color: var(--text-secondary, #506360);\n}\n.rcti-payment-result.info {\n  border-color: var(--info-border, #c8dcf8);\n  background: var(--info-soft, #eff6ff);\n  color: var(--info-text, #315b8f);\n}\n.rcti-payment-result.error {\n  border-color: var(--danger-default, #c23a2b);\n  background: var(--danger-soft, #fef2f1);\n  color: var(--danger-text, #a3301f);\n}\n.rcti-payment-result.success {\n  border-color: var(--success-default, #15703d);\n  background: var(--success-soft, #edfbf2);\n  color: var(--success-text, #115a33);\n}\n.rcti-payment-result.success > svg {\n  color: var(--success-default, #15703d);\n}\n.rcti-payment-dialog-actions {\n  display: flex;\n  min-height: 72px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 24px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.rcti-payment-dialog-actions button {\n  display: inline-flex;\n  height: 40px;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: normal 500 13px/normal var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.rcti-payment-dialog-actions button:hover:not(:disabled) {\n  border-color: var(--interactive-default, #0f766e);\n  color: var(--interactive-default, #0f766e);\n}\n.rcti-payment-dialog-actions button.primary {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n}\n.rcti-payment-dialog-actions button.primary:hover:not(:disabled) {\n  border-color: var(--interactive-hover, #0a655f);\n  background: var(--interactive-hover, #0a655f);\n  color: var(--on-interactive-primary, #fff);\n}\n.rcti-payment-dialog-actions button:disabled {\n  border-color: var(--interactive-disabled, #cdd6d4);\n  background: var(--interactive-disabled, #cdd6d4);\n  color: var(--on-interactive-disabled, #8a9896);\n  cursor: not-allowed;\n}\n.rcti-payment-dialog-actions button svg {\n  width: 16px;\n  height: 16px;\n}\n.rcti-payment-backdrop.dark .rcti-payment-dialog {\n  border-color: var(--border-subtle);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.rcti-payment-backdrop.dark .rcti-payment-dialog-header,\n.rcti-payment-backdrop.dark .rcti-payment-dialog-actions {\n  border-color: var(--border-subtle);\n}\n.rcti-payment-backdrop.dark .rcti-payment-dialog-header button {\n  color: var(--text-secondary);\n}\n.rcti-payment-backdrop.dark .rcti-payment-dialog-header button:hover {\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n}\n.rcti-payment-backdrop.dark .rcti-payment-summary {\n  border-color: var(--border-subtle);\n  background: var(--surface-secondary);\n}\n.rcti-payment-backdrop.dark .rcti-payment-summary > p {\n  color: var(--text-secondary);\n}\n.rcti-payment-backdrop.dark .rcti-payment-fields label input,\n.rcti-payment-backdrop.dark .rcti-payment-fields label select {\n  border-color: var(--border-default);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.rcti-payment-backdrop.dark .rcti-payment-disclaimer {\n  color: var(--text-secondary);\n}\n.rcti-payment-backdrop.dark .rcti-payment-result.info {\n  border-color: var(--info-border);\n  background: var(--info-soft);\n  color: var(--info-text);\n}\n.rcti-payment-backdrop.dark .rcti-payment-result.error {\n  border-color: var(--danger-border);\n  background: var(--danger-soft);\n  color: var(--danger-text);\n}\n.rcti-payment-backdrop.dark .rcti-payment-result.success {\n  border-color: var(--success-border);\n  background: var(--success-soft);\n  color: var(--success-text);\n}\n.rcti-payment-backdrop.dark .rcti-payment-result span {\n  color: var(--text-secondary);\n}\n.rcti-payment-backdrop.dark .rcti-payment-dialog-actions button:not(.primary) {\n  border-color: var(--border-default);\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n}\n.rcti-payment-backdrop.dark .rcti-payment-dialog-actions button.primary {\n  border-color: var(--interactive-default);\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n}\n.rcti-payment-backdrop.dark .rcti-payment-dialog-actions button:disabled {\n  border-color: var(--interactive-disabled);\n  background: var(--interactive-disabled);\n  color: var(--on-interactive-disabled);\n}\n\n@media (max-width: 700px) {\n  .rcti-overdue-notice {\n    align-items: flex-start;\n    flex-wrap: wrap;\n    margin: 0 0 12px;\n    padding: 12px;\n  }\n  .rcti-overdue-notice > div {\n    flex-basis: calc(100% - 38px);\n  }\n  .rcti-overdue-notice button {\n    margin-left: 30px;\n  }\n  .rcti-load-error {\n    flex-wrap: wrap;\n    margin: 20px auto;\n    padding: 16px;\n  }\n  .rcti-load-error > div {\n    flex-basis: calc(100% - 42px);\n  }\n  .rcti-payment-backdrop {\n    align-items: flex-end;\n    padding: 0;\n  }\n  .rcti-payment-dialog {\n    width: 100%;\n    max-height: min(92dvh, 800px);\n    border-right: 0;\n    border-bottom: 0;\n    border-left: 0;\n    border-radius: 16px 16px 0 0;\n  }\n  .rcti-payment-dialog-header {\n    min-height: 60px;\n    padding: 0 16px;\n  }\n  .rcti-payment-dialog-header h2 {\n    font-size: 18px;\n  }\n  .rcti-payment-dialog-body {\n    gap: 16px;\n    padding: 16px;\n  }\n  .rcti-payment-summary {\n    padding: 12px;\n  }\n  .rcti-payment-summary-main {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 4px;\n  }\n  .rcti-payment-fields {\n    grid-template-columns: 1fr;\n    gap: 14px;\n  }\n  .rcti-payment-fields .rcti-payment-reference {\n    grid-column: auto;\n  }\n  .rcti-payment-dialog-actions {\n    position: sticky;\n    bottom: 0;\n    min-height: 64px;\n    padding: 10px 16px calc(10px + env(safe-area-inset-bottom));\n    background: var(--surface-primary, #fff);\n  }\n  .rcti-payment-dialog-actions button {\n    min-height: 44px;\n    flex: 1;\n  }\n  .rcti-payment-backdrop.dark .rcti-payment-dialog-actions {\n    background: var(--surface-primary);\n  }\n  .rcti-history-load-error {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n/* Invoice-style paper hierarchy shared by details, preview and website capture. */\n.rcti-paper-business {\n  display: grid;\n  gap: var(--space-2);\n  min-width: 0;\n}\n.rcti-paper-business > .rcti-type-emphasis {\n  font-size: var(--font-size-h4);\n}\n.rcti-paper-business small,\n.rcti-paper-parties small {\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n  overflow-wrap: anywhere;\n}\n.rcti-detail-document .rcti-document-eyebrow {\n  font-size: var(--font-size-caption-md);\n  letter-spacing: 0.7px;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n.rcti-detail-document .rcti-paper-identity h2 {\n  margin: var(--space-1) 0;\n  font-size: var(--font-size-h2);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-primary);\n}\n.rcti-paper-parties {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: var(--space-5);\n  padding: var(--space-4) 0 var(--space-6);\n}\n.rcti-paper-parties > div {\n  display: grid;\n  align-content: start;\n  gap: var(--space-2);\n  min-width: 0;\n}\n.rcti-paper-parties > div > span {\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.rcti-paper-parties strong {\n  color: var(--text-primary);\n  font-size: var(--font-size-body-md);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-preview-page {\n  max-width: 1060px;\n  margin: 0 auto;\n  padding: var(--space-6);\n}\n.rcti-preview-toolbar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n  margin-bottom: var(--space-6);\n}\n.rcti-preview-toolbar h1 {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: var(--font-size-h3);\n}\n.rcti-preview-toolbar p {\n  margin: var(--space-1) 0 0;\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-preview-toolbar__actions {\n  display: flex;\n  gap: var(--space-3);\n  margin-left: auto;\n}\n.rcti-preview-toolbar button,\n.rcti-preview-error button {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  min-height: 42px;\n  padding: var(--space-3) var(--space-4);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  font: inherit;\n  cursor: pointer;\n}\n.rcti-preview-toolbar button.primary {\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n  border-color: var(--interactive-default);\n}\n.rcti-preview-toolbar button:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.rcti-preview-toolbar button:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n.rcti-preview-error {\n  color: var(--danger-text);\n  background: var(--danger-soft);\n  border: 1px solid var(--danger-default);\n  border-radius: var(--radius-md);\n  padding: var(--space-5);\n}\n@media (max-width: 600px) {\n  .rcti-paper-heading {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .rcti-paper-parties {\n    grid-template-columns: 1fr;\n  }\n  .rcti-preview-page {\n    padding: var(--space-4);\n  }\n  .rcti-preview-toolbar__actions {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n@media print {\n  .rcti-preview-toolbar {\n    display: none;\n  }\n  .rcti-preview-page {\n    padding: 0;\n    max-width: none;\n  }\n  .rcti-preview-page .rcti-detail-document {\n    box-shadow: none;\n    border: 0;\n  }\n}\n\n.rcti-detail-items [data-label=\"GST\"] small {\n  display: block;\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n\n.rcti-detail-document .rcti-paper-identity {\n  flex: 1 1 55%;\n  min-width: 0;\n}\n.rcti-paper-business {\n  flex: 1 1 40%;\n}\n.rcti-document-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n}\n.rcti-document-table {\n  width: 100%;\n  min-width: 680px;\n  border-collapse: collapse;\n  color: var(--text-primary);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-document-table th {\n  padding: var(--space-3);\n  background: var(--surface-secondary);\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n  font-weight: var(--font-weight-medium);\n  border-bottom: 1px solid var(--border-default);\n  text-align: right;\n  white-space: nowrap;\n}\n.rcti-document-table td {\n  padding: var(--space-4) var(--space-3);\n  border-bottom: 1px solid var(--border-default);\n  text-align: right;\n  vertical-align: top;\n  white-space: nowrap;\n}\n.rcti-document-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n.rcti-document-table th:first-child,\n.rcti-document-table td:first-child {\n  text-align: left;\n  width: 40%;\n  white-space: normal;\n  min-width: 180px;\n  overflow-wrap: anywhere;\n}\n.rcti-document-table strong {\n  font-weight: var(--font-weight-medium);\n}\n.rcti-document-table small {\n  display: block;\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n  white-space: normal;\n  margin-top: var(--space-1);\n}\n@media print {\n  .rcti-document-table-scroll {\n    overflow: visible;\n  }\n  .rcti-document-table {\n    min-width: 0;\n  }\n  .rcti-document-table thead {\n    display: table-header-group;\n  }\n  .rcti-document-table tr {\n    break-inside: avoid;\n  }\n}\n\n/* Document totals and statutory notes must retain contrast in both themes. */\n.rcti-detail-document .rcti-detail-section-description,\n.rcti-detail-document .rcti-detail-summary p > span:first-child {\n  color: var(--text-secondary);\n}\n.rcti-detail-document .rcti-detail-summary p > span:last-child {\n  color: var(--text-primary);\n}\n.rcti-detail-document .rcti-detail-summary .grand {\n  padding: var(--space-4);\n  margin-top: var(--space-3);\n  background: var(--surface-secondary);\n  border-radius: var(--radius-md);\n}\n.rcti-detail-document .rcti-detail-summary .grand > span {\n  color: var(--text-primary);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-detail-document hr {\n  border-color: var(--border-default);\n}\n.rcti-paper-parties > div:last-child > strong {\n  text-transform: capitalize;\n}\n@media print {\n  .rcti-preview-shell,\n  .rcti-detail-document {\n    --surface-primary: #fff;\n    --surface-secondary: #f4f7f7;\n    --text-primary: #142624;\n    --text-secondary: #506360;\n    --border-default: #dce3e2;\n    background: #fff !important;\n  }\n}\n.rcti-detail-document .rcti-detail-summary .grand > span:last-child {\n  font-size: var(--font-size-h4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
